// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20%20%22%3E%3C/svg%3E#}https://planzer.io/wp-content/uploads/2023/01/bg-shape-5.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! elementor-pro - v3.21.0 - 15-04-2024 */
@charset "UTF-8";

/*! This file is auto-generated */



/*! elementor - v3.22.0 - 26-06-2024 */
.elementor *,
.elementor :after,
.elementor :before {
  box-sizing: border-box;
}
.elementor a {
  box-shadow: none;
  text-decoration: none;
}
.elementor img {
  height: auto;
  max-width: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.elementor
  .elementor-widget:not(.elementor-widget-text-editor):not(
    .elementor-widget-theme-post-content
  )
  figure {
  margin: 0;
}
.e-con-inner > .elementor-element.elementor-absolute,
.e-con > .elementor-element.elementor-absolute {
  position: absolute;
}
.elementor-element {
  --flex-direction: initial;
  --flex-wrap: initial;
  --justify-content: initial;
  --align-items: initial;
  --align-content: initial;
  --gap: initial;
  --flex-basis: initial;
  --flex-grow: initial;
  --flex-shrink: initial;
  --order: initial;
  --align-self: initial;
  flex-basis: var(--flex-basis);
  flex-grow: var(--flex-grow);
  flex-shrink: var(--flex-shrink);
  order: var(--order);
  align-self: var(--align-self);
}
.elementor-element.elementor-absolute {
  z-index: 1;
}
.elementor-element:where(.e-con-full, .elementor-widget) {
  flex-direction: var(--flex-direction);
  flex-wrap: var(--flex-wrap);
  justify-content: var(--justify-content);
  align-items: var(--align-items);
  align-content: var(--align-content);
  gap: var(--gap);
}
.elementor-invisible {
  visibility: hidden;
}
.elementor-align-right {
  text-align: right;
}
.elementor-align-right .elementor-button {
  width: auto;
}
.elementor-align-left {
  text-align: left;
}
.elementor-align-left .elementor-button {
  width: auto;
}
@media (max-width: 767px) {
  .elementor-mobile-align-justify .elementor-button {
    width: 100%;
  }
}
:root {
  --page-title-display: block;
}
@keyframes eicon-spin {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.elementor-widget {
  position: relative;
}
.elementor-widget:not(:last-child) {
  margin-bottom: 20px;
}
.elementor-widget:not(:last-child).elementor-absolute,
.elementor-widget:not(:last-child).elementor-widget__width-initial {
  margin-bottom: 0;
}
ul.elementor-icon-list-items.elementor-inline-items {
  display: flex;
  flex-wrap: wrap;
}
ul.elementor-icon-list-items.elementor-inline-items .elementor-inline-item {
  word-break: break-word;
}
.e-con {
  --border-radius: 0;
  --border-top-width: 0px;
  --border-right-width: 0px;
  --border-bottom-width: 0px;
  --border-left-width: 0px;
  --border-style: initial;
  --border-color: initial;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --content-width: min(100%, var(--container-max-width, 1140px));
  --width: 100%;
  --min-height: initial;
  --height: auto;
  --text-align: initial;
  --margin-top: 0px;
  --margin-right: 0px;
  --margin-bottom: 0px;
  --margin-left: 0px;
  --padding-top: var(--container-default-padding-top, 10px);
  --padding-right: var(--container-default-padding-right, 10px);
  --padding-bottom: var(--container-default-padding-bottom, 10px);
  --padding-left: var(--container-default-padding-left, 10px);
  --position: relative;
  --z-index: revert;
  --overflow: visible;
  --gap: var(--widgets-spacing, 20px);
  --overlay-mix-blend-mode: initial;
  --overlay-opacity: 1;
  --overlay-transition: 0.3s;
  --e-con-grid-template-columns: repeat(3, 1fr);
  --e-con-grid-template-rows: repeat(2, 1fr);
  position: var(--position);
  width: var(--width);
  min-width: 0;
  min-height: var(--min-height);
  height: var(--height);
  border-radius: var(--border-radius);
  z-index: var(--z-index);
  overflow: var(--overflow);
  transition: background var(--background-transition, 0.3s),
    border var(--border-transition, 0.3s),
    box-shadow var(--border-transition, 0.3s),
    transform var(--e-con-transform-transition-duration, 0.4s);
  --flex-wrap-mobile: wrap;
  margin-block-start: var(--margin-block-start);
  margin-inline-end: var(--margin-inline-end);
  margin-block-end: var(--margin-block-end);
  margin-inline-start: var(--margin-inline-start);
  padding-inline-start: var(--padding-inline-start);
  padding-inline-end: var(--padding-inline-end);
  --margin-block-start: var(--margin-top);
  --margin-block-end: var(--margin-bottom);
  --margin-inline-start: var(--margin-left);
  --margin-inline-end: var(--margin-right);
  --padding-inline-start: var(--padding-left);
  --padding-inline-end: var(--padding-right);
  --padding-block-start: var(--padding-top);
  --padding-block-end: var(--padding-bottom);
  --border-block-start-width: var(--border-top-width);
  --border-block-end-width: var(--border-bottom-width);
  --border-inline-start-width: var(--border-left-width);
  --border-inline-end-width: var(--border-right-width);
}
.e-con.e-flex {
  --flex-direction: column;
  --flex-basis: auto;
  --flex-grow: 0;
  --flex-shrink: 1;
  flex: var(--flex-grow) var(--flex-shrink) var(--flex-basis);
}
.e-con-full,
.e-con > .e-con-inner {
  text-align: var(--text-align);
  padding-block-start: var(--padding-block-start);
  padding-block-end: var(--padding-block-end);
}
.e-con-full.e-flex,
.e-con.e-flex > .e-con-inner {
  flex-direction: var(--flex-direction);
}
.e-con,
.e-con > .e-con-inner {
  display: var(--display);
}
.e-con-boxed.e-flex {
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: normal;
  align-items: normal;
  align-content: normal;
}
.e-con-boxed {
  text-align: initial;
  gap: initial;
}
.e-con.e-flex > .e-con-inner {
  flex-wrap: var(--flex-wrap);
  justify-content: var(--justify-content);
  align-items: var(--align-items);
  align-content: var(--align-content);
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  align-self: auto;
}
.e-con > .e-con-inner {
  gap: var(--gap);
  width: 100%;
  max-width: var(--content-width);
  margin: 0 auto;
  padding-inline-start: 0;
  padding-inline-end: 0;
  height: 100%;
}
:is( [data-elementor-id]) > .e-con {
  --margin-left: auto;
  --margin-right: auto;
  max-width: min(100%, var(--width));
}
.e-con .elementor-widget.elementor-widget {
  margin-block-end: 0;
}
.e-con:before {
  content: var(--background-overlay);
  display: block;
  position: absolute;
  mix-blend-mode: var(--overlay-mix-blend-mode);
  opacity: var(--overlay-opacity);
  transition: var(--overlay-transition, 0.3s);
  border-radius: var(--border-radius);
  border-style: var(--border-style);
  border-color: var(--border-color);
  border-block-start-width: var(--border-block-start-width);
  border-inline-end-width: var(--border-inline-end-width);
  border-block-end-width: var(--border-block-end-width);
  border-inline-start-width: var(--border-inline-start-width);
  top: calc(0px - var(--border-top-width));
  left: calc(0px - var(--border-left-width));
  width: max(100% + var(--border-left-width) + var(--border-right-width), 100%);
  height: max(
    100% + var(--border-top-width) + var(--border-bottom-width),
    100%
  );
}
.e-con:before {
  transition: background var(--overlay-transition, 0.3s),
    border-radius var(--border-transition, 0.3s),
    opacity var(--overlay-transition, 0.3s);
}
.e-con .elementor-widget {
  min-width: 0;
}
.e-con > .e-con-inner > .elementor-widget > .elementor-widget-container,
.e-con > .elementor-widget > .elementor-widget-container {
  height: 100%;
}
.e-con.e-con > .e-con-inner > .elementor-widget,
.elementor.elementor .e-con > .elementor-widget {
  max-width: 100%;
}
@media (max-width: 767px) {
  .e-con.e-flex {
    --width: 100%;
    --flex-wrap: var(--flex-wrap-mobile);
  }
}
.elementor-element .elementor-widget-container {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s,
    transform var(--e-transform-transition-duration, 0.4s);
}
.elementor-button {
  display: inline-block;
  line-height: 1;
  background-color: #69727d;
  font-size: 15px;
  padding: 12px 24px;
  border-radius: 3px;
  color: #fff;
  fill: #fff;
  text-align: center;
  transition: all 0.3s;
}
.elementor-button:focus,
.elementor-button:hover,
.elementor-button:visited {
  color: #fff;
}
.elementor-button-content-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 5px;
}
.elementor-button-icon svg {
  width: 1em;
  height: auto;
}
.elementor-button-text {
  display: inline-block;
}
.elementor-button span {
  text-decoration: inherit;
}
.elementor-element {
  --swiper-theme-color: #000;
  --swiper-navigation-size: 44px;
  --swiper-pagination-bullet-size: 6px;
  --swiper-pagination-bullet-horizontal-gap: 6px;
}
.elementor-shape {
  overflow: hidden;
  position: absolute;
  left: 0;
  width: 100%;
  line-height: 0;
  direction: ltr;
}
.elementor-shape-bottom {
  bottom: -1px;
}
.elementor-shape-bottom:not([data-negative="true"]) svg {
  z-index: -1;
}
.elementor-shape[data-negative="false"].elementor-shape-bottom {
  transform: rotate(180deg);
}
.elementor-shape svg {
  display: block;
  width: calc(100% + 1.3px);
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.elementor-shape .elementor-shape-fill {
  fill: #fff;
  transform-origin: center;
  transform: rotateY(0deg);
}

.elementor .elementor-element ul.elementor-icon-list-items {
  padding: 0;
}

@keyframes e-contact-buttons-typing-jump {
  0% {
    bottom: 0;
  }
  20% {
    bottom: 5px;
  }
  40% {
    bottom: 0;
  }
}
@keyframes e-contact-buttons-appear {
  0% {
    height: 0;
    opacity: 0;
    visibility: hidden;
  }
  to {
    height: auto;
    opacity: 1;
    visibility: visible;
  }
}
@keyframes e-contact-buttons-disappear {
  0% {
    display: inline-flex;
  }
  to {
    display: none;
  }
}
@keyframes e-contact-buttons-close {
  0%,
  99.99% {
    visibility: visible;
    opacity: 1;
  }
  to {
    visibility: hidden;
    opacity: 0;
    transform: none;
  }
}
.elementor-kit-159 {
  --e-global-color-primary: #7a7d9c;
  --e-global-color-secondary: #54595f;
  --e-global-color-text: #7a7d9c;
  --e-global-color-accent: #5335d9;
  --e-global-color-inverse_primary: #0b0a33;
  --e-global-color-6545aeb: #f2f5ff;
  --e-global-color-0b8b4d2: #ffffff;
  --e-global-color-ce0cfb7: #d9dbe9;
  --e-global-typography-primary-font-family: "thicccboi";
  --e-global-typography-primary-font-size: 2.5rem;
  --e-global-typography-primary-font-weight: 700;
  --e-global-typography-primary-line-height: 1.4em;
  --e-global-typography-secondary-font-family: "thicccboi";
  --e-global-typography-text-font-family: "thicccboi";
  --e-global-typography-text-font-size: 1.125rem;
  --e-global-typography-text-font-weight: 500;
  --e-global-typography-text-line-height: 1.58em;
  --e-global-typography-accent-font-family: "thicccboi";
  --e-global-typography-accent-font-size: 1.125rem;
  --e-global-typography-accent-font-weight: 700;
  --e-global-typography-accent-line-height: 1.11em;
  --e-global-typography-inverse_primary-font-family: "thicccboi";
  --e-global-typography-e9e97e1-font-family: "thicccboi";
  --e-global-typography-e9e97e1-font-size: 40px;
  --e-global-typography-e9e97e1-font-weight: 700;
  --e-global-typography-e9e97e1-line-height: 1.3em;
  --e-global-typography-d2ffb97-font-family: "thicccboi";
  --e-global-typography-d2ffb97-font-size: 28px;
  --e-global-typography-d2ffb97-font-weight: 700;
  --e-global-typography-d2ffb97-line-height: 1.3em;
  color: var(--e-global-color-text);
  font-family: "thicccboi", Sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.667em;
}
.elementor-kit-159 p {
  margin-bottom: 24px;
}
.elementor-kit-159 a {
  color: var(--e-global-color-inverse_primary);
}
.elementor-kit-159 a:hover {
  color: #4457ff;
}
.elementor-kit-159 h1 {
  color: var(--e-global-color-inverse_primary);
  letter-spacing: -0.01em;
}
.elementor-kit-159 h2 {
  color: var(--e-global-color-inverse_primary);
  font-family: var(--e-global-typography-e9e97e1-font-family), Sans-serif;
  font-size: var(--e-global-typography-e9e97e1-font-size);
  font-weight: var(--e-global-typography-e9e97e1-font-weight);
  line-height: var(--e-global-typography-e9e97e1-line-height);
  letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);
  word-spacing: var(--e-global-typography-e9e97e1-word-spacing);
}
.elementor-kit-159 h3 {
  color: var(--e-global-color-inverse_primary);
  font-family: var(--e-global-typography-d2ffb97-font-family), Sans-serif;
  font-size: var(--e-global-typography-d2ffb97-font-size);
  font-weight: var(--e-global-typography-d2ffb97-font-weight);
  line-height: var(--e-global-typography-d2ffb97-line-height);
  letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);
  word-spacing: var(--e-global-typography-d2ffb97-word-spacing);
}
.elementor-kit-159 button,
.elementor-kit-159 .elementor-button {
  font-family: "thicccboi", Sans-serif;
  color: var(--e-global-color-0b8b4d2);
  background-color: var(--e-global-color-accent);
  border-radius: 50px 50px 50px 50px;
  padding: 22px 42px 22px 42px;
}
.elementor-kit-159 button:hover,
.elementor-kit-159 button:focus,
.elementor-kit-159 .elementor-button:hover,
.elementor-kit-159 .elementor-button:focus {
  color: #fff;
  background-color: var(--e-global-color-inverse_primary);
}
.e-con {
  --container-max-width: 1140px;
}
.elementor-widget:not(:last-child) {
  margin-block-end: 20px;
}
.elementor-element {
  --widgets-spacing: 20px 20px;
}
@media (max-width: 1024px) {
  .elementor-kit-159 {
    --e-global-typography-e9e97e1-font-size: 30px;
  }
  .elementor-kit-159 h2 {
    font-size: var(--e-global-typography-e9e97e1-font-size);
    line-height: var(--e-global-typography-e9e97e1-line-height);
    letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);
    word-spacing: var(--e-global-typography-e9e97e1-word-spacing);
  }
  .elementor-kit-159 h3 {
    font-size: var(--e-global-typography-d2ffb97-font-size);
    line-height: var(--e-global-typography-d2ffb97-line-height);
    letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);
    word-spacing: var(--e-global-typography-d2ffb97-word-spacing);
  }
  .e-con {
    --container-max-width: 1024px;
  }
}
@media (max-width: 767px) {
  .elementor-kit-159 {
    --e-global-typography-text-font-size: 1rem;
    --e-global-typography-e9e97e1-font-size: 26px;
    --e-global-typography-e9e97e1-line-height: 1.2em;
    font-size: 1rem;
  }
  .elementor-kit-159 h2 {
    font-size: var(--e-global-typography-e9e97e1-font-size);
    line-height: var(--e-global-typography-e9e97e1-line-height);
    letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);
    word-spacing: var(--e-global-typography-e9e97e1-word-spacing);
  }
  .elementor-kit-159 h3 {
    font-size: var(--e-global-typography-d2ffb97-font-size);
    line-height: var(--e-global-typography-d2ffb97-line-height);
    letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);
    word-spacing: var(--e-global-typography-d2ffb97-word-spacing);
  }
  .e-con {
    --container-max-width: 767px;
  }
}
.elementor-animation-shrink {
  transform: scale3d(1, 1, 1.01) !important;
}
.elementor-animation-shrink:hover {
  transform: scale3d(0.95, 0.95, 1.01) !important;
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf590592ecb6f2_THICCCBOI-Bold.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf597b00ecb6f3_THICCCBOI-Medium.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf599227ecb6f4_THICCCBOI-SemiBold.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62e22028e877056d28819f41_THICCCBOI-Regular.ttf)
    format("truetype");
}

/**
 * Swiper 8.4.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2022 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 21, 2022
 */
@font-face {
  font-family: swiper-icons;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}
:root {
  --swiper-navigation-size: 44px;
}
@keyframes swiper-preloader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*! elementor-pro - v3.21.0 - 15-04-2024 */
.elementor-1652 .elementor-element.elementor-element-df61ea6 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --align-items: center;
  --background-transition: 0.3s;
  --padding-top: 110px;
  --padding-bottom: 220px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-df61ea6:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-color: var(--e-global-color-6545aeb);
}
.elementor-1652 .elementor-element.elementor-element-df61ea6,
.elementor-1652 .elementor-element.elementor-element-df61ea6::before {
  --border-transition: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-df61ea6
  > .elementor-shape-bottom
  svg,
.elementor-1652
  .elementor-element.elementor-element-df61ea6
  > .e-con-inner
  > .elementor-shape-bottom
  svg {
  height: 180px;
  transform: translateX(-50%) rotateY(180deg);
}
.elementor-1652
  .elementor-element.elementor-element-287395a
  .elementor-icon-box-title,
.elementor-1652
  .elementor-element.elementor-element-287395a
  .elementor-icon-box-title
  a {
  font-family: "thicccboi", Sans-serif;
  font-size: 58px;
  font-weight: 700;
  line-height: 1.3em;
}
.elementor-1652
  .elementor-element.elementor-element-287395a
  .elementor-icon-box-description {
  font-family: "thicccboi", Sans-serif;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.667em;
}
.elementor-1652
  .elementor-element.elementor-element-287395a
  > .elementor-widget-container {
  margin: 0 0 30px 0;
}
.elementor-1652 .elementor-element.elementor-element-287395a {
  width: var(--container-widget-width, 610px);
  max-width: 610px;
  --container-widget-width: 610px;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-items:not(.elementor-inline-items)
  .elementor-icon-list-item:not(:last-child) {
  padding-bottom: calc(25px / 2);
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-items:not(.elementor-inline-items)
  .elementor-icon-list-item:not(:first-child) {
  margin-top: calc(25px / 2);
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-items.elementor-inline-items
  .elementor-icon-list-item {
  margin-right: calc(25px / 2);
  margin-left: calc(25px / 2);
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-items.elementor-inline-items {
  margin-right: calc(-25px / 2);
  margin-left: calc(-25px / 2);
}
body:not(.rtl)
  .elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-items.elementor-inline-items
  .elementor-icon-list-item:after {
  right: calc(-25px / 2);
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-icon
  i {
  color: var(--e-global-color-accent);
  transition: color 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-icon
  svg {
  fill: var(--e-global-color-accent);
  transition: fill 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-item:hover
  .elementor-icon-list-icon
  i {
  color: var(--e-global-color-0b8b4d2);
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-item:hover
  .elementor-icon-list-icon
  svg {
  fill: var(--e-global-color-0b8b4d2);
}
.elementor-1652 .elementor-element.elementor-element-37ea6f4 {
  --e-icon-list-icon-size: 20px;
  --icon-vertical-offset: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-text {
  color: var(--e-global-color-accent);
  transition: color 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-item:hover
  .elementor-icon-list-text {
  color: var(--e-global-color-0b8b4d2);
}
.elementor-1652 .elementor-element.elementor-element-13b0a15 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: center;
  --gap: 6% 6%;
  --background-transition: 0.3s;
  --padding-top: 50px;
  --padding-bottom: 50px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652 .elementor-element.elementor-element-1ee596c {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
  --border-radius: 30px 30px 30px 30px;
  --padding-top: 40px;
  --padding-bottom: 40px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-1ee596c:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-color: var(--e-global-color-6545aeb);
}
.elementor-1652 .elementor-element.elementor-element-1ee596c,
.elementor-1652 .elementor-element.elementor-element-1ee596c::before {
  --border-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-8ee0213 img {
  width: 90%;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 12px 60px 0
    rgba(32, 36.00000000000005, 138, 0.058823529411764705);
}
.elementor-1652 .elementor-element.elementor-element-8039c31 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-86264bd .elementor-button {
  font-family: "thicccboi", Sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.11em;
  letter-spacing: 0.6px;
  fill: var(--e-global-color-accent);
  color: var(--e-global-color-accent);
  background-color: #f3f5ff;
  padding: 14px 24px 14px 24px;
}
.elementor-1652
  .elementor-element.elementor-element-86264bd
  > .elementor-widget-container {
  margin: 0 0 10px 0;
}
.elementor-1652
  .elementor-element.elementor-element-04e3ec4
  .elementor-icon-box-wrapper {
  text-align: left;
}
.elementor-1652 .elementor-element.elementor-element-8c0b439 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: flex-start;
  --gap: 2% 2%;
  --flex-wrap: wrap;
  --background-transition: 0.3s;
  --padding-top: 0px;
  --padding-bottom: 100px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-363e4a7
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-363e4a7 {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-43a1a89
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-43a1a89 {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-926997b.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-926997b
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-926997b {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652 .elementor-element.elementor-element-656778a {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: center;
  --gap: 6% 6%;
  --background-transition: 0.3s;
  --padding-top: 100px;
  --padding-bottom: 80px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652 .elementor-element.elementor-element-229ba6d {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-a7504da .elementor-button {
  font-family: "thicccboi", Sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.11em;
  letter-spacing: 0.6px;
  fill: var(--e-global-color-accent);
  color: var(--e-global-color-accent);
  background-color: #f3f5ff;
  padding: 14px 24px 14px 24px;
}
.elementor-1652
  .elementor-element.elementor-element-a7504da
  > .elementor-widget-container {
  margin: 0 0 10px 0;
}
.elementor-1652
  .elementor-element.elementor-element-75e417e
  .elementor-icon-box-wrapper {
  text-align: left;
}
.elementor-1652 .elementor-element.elementor-element-1f388bb {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
  --border-radius: 30px 30px 30px 30px;
}
.elementor-1652
  .elementor-element.elementor-element-1f388bb:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-color: var(--e-global-color-6545aeb);
}
.elementor-1652 .elementor-element.elementor-element-1f388bb,
.elementor-1652 .elementor-element.elementor-element-1f388bb::before {
  --border-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-5126345 {
  text-align: right;
}
.elementor-1652 .elementor-element.elementor-element-5126345 img {
  width: 100%;
}
.elementor-1652 .elementor-element.elementor-element-eaae3f2 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: flex-start;
  --gap: 2% 2%;
  --flex-wrap: wrap;
  --background-transition: 0.3s;
  --padding-top: 0px;
  --padding-bottom: 100px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-136561f.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-136561f
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-136561f {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-1d2c35c
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-1d2c35c {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-ea4471c
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-ea4471c {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652 .elementor-element.elementor-element-f1228cf {
  --display: flex;
  --background-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-6ae8ef6 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: center;
  --gap: 6% 6%;
  --background-transition: 0.3s;
  --padding-top: 150px;
  --padding-bottom: 100px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652 .elementor-element.elementor-element-95f4f13 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
  --border-radius: 30px 30px 30px 30px;
  --padding-top: 40px;
  --padding-bottom: 40px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-95f4f13:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-color: var(--e-global-color-6545aeb);
}
.elementor-1652 .elementor-element.elementor-element-95f4f13,
.elementor-1652 .elementor-element.elementor-element-95f4f13::before {
  --border-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-7e97d70 img {
  width: 91%;
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #d9dbe96e;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 12px 60px 0
    rgba(32, 36.00000000000005, 138, 0.058823529411764705);
}
.elementor-1652 .elementor-element.elementor-element-e0d7628 img {
  width: 332px;
  border-radius: 30px 30px 30px 30px;
}
body:not(.rtl) .elementor-1652 .elementor-element.elementor-element-e0d7628 {
  left: -101px;
}
.elementor-1652 .elementor-element.elementor-element-e0d7628 {
  top: 286px;
}
.elementor-1652 .elementor-element.elementor-element-3f5911a {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
}
.elementor-1652 .elementor-element.elementor-element-65d4e04 .elementor-button {
  font-family: "thicccboi", Sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.11em;
  letter-spacing: 0.6px;
  fill: var(--e-global-color-accent);
  color: var(--e-global-color-accent);
  background-color: #f3f5ff;
  padding: 14px 24px 14px 24px;
}
.elementor-1652
  .elementor-element.elementor-element-65d4e04
  > .elementor-widget-container {
  margin: 0 0 10px 0;
}
.elementor-1652
  .elementor-element.elementor-element-e0df2b7
  .elementor-icon-box-wrapper {
  text-align: left;
}
.elementor-1652 .elementor-element.elementor-element-a1cd467 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: calc(
    (1 - var(--container-widget-flex-grow)) * 100%
  );
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --align-items: flex-start;
  --gap: 2% 2%;
  --flex-wrap: wrap;
  --background-transition: 0.3s;
  --padding-top: 0px;
  --padding-bottom: 120px;
  --padding-left: 0px;
  --padding-right: 0px;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-155c3b7
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-155c3b7 {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-68f847b
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-68f847b {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  .elementor-image-box-wrapper {
  text-align: left;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4.elementor-position-top
  .elementor-image-box-img {
  margin-bottom: 17px;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  .elementor-image-box-title {
  margin-bottom: 15px;
  color: var(--e-global-color-inverse_primary);
  font-family: "thicccboi", Sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2em;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  .elementor-image-box-wrapper
  .elementor-image-box-img {
  width: 25%;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  .elementor-image-box-img
  img {
  transition-duration: 0.3s;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  .elementor-image-box-description {
  font-size: 18px;
  line-height: 1.6em;
}
.elementor-1652
  .elementor-element.elementor-element-dd30db4
  > .elementor-widget-container {
  margin: 0 0 22px 0;
  padding: 48px 32px 52px 32px;
  background-color: var(--e-global-color-0b8b4d2);
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 20px 20px 20px 20px;
  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);
}
.elementor-1652 .elementor-element.elementor-element-dd30db4 {
  width: var(--container-widget-width, 32%);
  max-width: 32%;
  --container-widget-width: 32%;
  --container-widget-flex-grow: 0;
}
.elementor-1652 .elementor-element.elementor-element-89e89f8 {
  --display: flex;
  --background-transition: 0.3s;
}
@media (min-width: 768px) {
  .elementor-1652 .elementor-element.elementor-element-1ee596c {
    --width: 50%;
  }
  .elementor-1652 .elementor-element.elementor-element-8039c31 {
    --width: 50%;
  }
  .elementor-1652 .elementor-element.elementor-element-229ba6d {
    --width: 50%;
  }
  .elementor-1652 .elementor-element.elementor-element-1f388bb {
    --width: 50%;
  }
  .elementor-1652 .elementor-element.elementor-element-95f4f13 {
    --width: 50%;
  }
  .elementor-1652 .elementor-element.elementor-element-3f5911a {
    --width: 50%;
  }
}
@media (max-width: 1024px) {
  .elementor-1652
    .elementor-element.elementor-element-df61ea6
    > .elementor-shape-bottom
    svg,
  .elementor-1652
    .elementor-element.elementor-element-df61ea6
    > .e-con-inner
    > .elementor-shape-bottom
    svg {
    height: 100px;
  }
  .elementor-1652 .elementor-element.elementor-element-df61ea6 {
    --padding-top: 80px;
    --padding-bottom: 150px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-287395a
    .elementor-icon-box-title,
  .elementor-1652
    .elementor-element.elementor-element-287395a
    .elementor-icon-box-title
    a {
    font-size: 48px;
  }
  .elementor-1652 .elementor-element.elementor-element-13b0a15 {
    --gap: 2% 2%;
    --padding-top: 40px;
    --padding-bottom: 40px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-04e3ec4
    .elementor-icon-box-description {
    font-size: 1rem;
  }
  .elementor-1652 .elementor-element.elementor-element-8c0b439 {
    --padding-top: 0px;
    --padding-bottom: 80px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652 .elementor-element.elementor-element-656778a {
    --gap: 2% 2%;
    --padding-top: 40px;
    --padding-bottom: 40px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-75e417e
    .elementor-icon-box-description {
    font-size: 1rem;
  }
  .elementor-1652 .elementor-element.elementor-element-eaae3f2 {
    --padding-top: 0px;
    --padding-bottom: 80px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652 .elementor-element.elementor-element-6ae8ef6 {
    --gap: 2% 2%;
    --padding-top: 40px;
    --padding-bottom: 40px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-e0df2b7
    .elementor-icon-box-description {
    font-size: 1rem;
  }
  .elementor-1652 .elementor-element.elementor-element-a1cd467 {
    --padding-top: 0px;
    --padding-bottom: 80px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4.elementor-position-top
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 35%;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-title {
    font-size: 22px;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-description {
    font-size: 16px;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    > .elementor-widget-container {
    padding: 28px 28px 28px 28px;
  }
}
@media (max-width: 767px) {
  .elementor-1652
    .elementor-element.elementor-element-df61ea6
    > .elementor-shape-bottom
    svg,
  .elementor-1652
    .elementor-element.elementor-element-df61ea6
    > .e-con-inner
    > .elementor-shape-bottom
    svg {
    height: 50px;
  }
  .elementor-1652 .elementor-element.elementor-element-df61ea6 {
    --padding-top: 50px;
    --padding-bottom: 50px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-287395a
    .elementor-icon-box-title,
  .elementor-1652
    .elementor-element.elementor-element-287395a
    .elementor-icon-box-title
    a {
    font-size: 34px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-287395a
    .elementor-icon-box-description {
    font-size: 1rem;
    line-height: 1.5em;
  }
  .elementor-1652
    .elementor-element.elementor-element-287395a
    > .elementor-widget-container {
    margin: 0 0 0 0;
  }
  .elementor-1652 .elementor-element.elementor-element-37ea6f4 {
    width: 100%;
    max-width: 100%;
  }
  .elementor-1652 .elementor-element.elementor-element-13b0a15 {
    --padding-top: 20px;
    --padding-bottom: 20px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652 .elementor-element.elementor-element-1ee596c {
    --margin-top: 0px;
    --margin-bottom: 30px;
    --margin-left: 0px;
    --margin-right: 0px;
  }
  .elementor-1652
    .elementor-element.elementor-element-86264bd
    .elementor-button {
    font-size: 14px;
  }
  .elementor-1652
    .elementor-element.elementor-element-86264bd
    > .elementor-widget-container {
    margin: 0 0 0 0;
  }
  .elementor-1652 .elementor-element.elementor-element-8c0b439 {
    --padding-top: 10px;
    --padding-bottom: 50px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-363e4a7
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-363e4a7 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-43a1a89
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-43a1a89 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-926997b
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-926997b {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652 .elementor-element.elementor-element-656778a {
    --padding-top: 20px;
    --padding-bottom: 20px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652
    .elementor-element.elementor-element-a7504da
    .elementor-button {
    font-size: 14px;
  }
  .elementor-1652
    .elementor-element.elementor-element-a7504da
    > .elementor-widget-container {
    margin: 0 0 0 0;
  }
  .elementor-1652 .elementor-element.elementor-element-1f388bb {
    --margin-top: 0px;
    --margin-bottom: 30px;
    --margin-left: 0px;
    --margin-right: 0px;
  }
  .elementor-1652 .elementor-element.elementor-element-eaae3f2 {
    --padding-top: 10px;
    --padding-bottom: 50px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-136561f
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-136561f {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-1d2c35c
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-1d2c35c {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-ea4471c
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-ea4471c {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652 .elementor-element.elementor-element-6ae8ef6 {
    --padding-top: 20px;
    --padding-bottom: 20px;
    --padding-left: 20px;
    --padding-right: 20px;
  }
  .elementor-1652 .elementor-element.elementor-element-95f4f13 {
    --margin-top: 0px;
    --margin-bottom: 30px;
    --margin-left: 0px;
    --margin-right: 0px;
  }
  .elementor-1652
    .elementor-element.elementor-element-65d4e04
    .elementor-button {
    font-size: 14px;
  }
  .elementor-1652
    .elementor-element.elementor-element-65d4e04
    > .elementor-widget-container {
    margin: 0 0 0 0;
  }
  .elementor-1652 .elementor-element.elementor-element-a1cd467 {
    --padding-top: 10px;
    --padding-bottom: 50px;
    --padding-left: 10px;
    --padding-right: 10px;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-155c3b7
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-155c3b7 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-68f847b
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-68f847b {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-img {
    margin-bottom: 2px;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-title {
    margin-bottom: 1px;
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1652
    .elementor-element.elementor-element-dd30db4
    .elementor-image-box-wrapper
    .elementor-image-box-img {
    width: 25%;
  }
  .elementor-1652 .elementor-element.elementor-element-dd30db4 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-item
  a {
  padding: 22px 44px 22px 53px;
  border: 1px solid #eff0f6;
  border-radius: 10000000000px;
  background-color: #fff;
  box-shadow: 0 5px 5px 0 rgb(11 10 51 / 0.01),
    0 1px 3px 0 rgb(68 87 255 / 0.02), 0 4px 11px 0 rgb(68 87 255 / 0.06);
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  line-height: 1.111em;
}
.elementor-1652
  .elementor-element.elementor-element-37ea6f4
  .elementor-icon-list-item
  a:hover {
  border-color: #4457ff;
  background-color: #5335d9;
  box-shadow: none;
}
@media only screen and (max-width: 767px) {
  .elementor-1652 .elementor-element.elementor-element-37ea6f4 ul {
    flex-direction: column !important;
  }
  .elementor-1652 .elementor-element.elementor-element-37ea6f4 ul li {
    margin: 0 0 10px 0;
  }
}
.elementor-1652 .elementor-element.elementor-element-8c0b439 img {
  border-radius: 24%;
}
.im-bx-r img {
  border-radius: 24%;
}
.elementor-1652 .elementor-element.elementor-element-e0d7628 img {
  box-shadow: 0 11px 24px 0 rgb(32 36 138 / 9%);
}
.elementor-1652 .elementor-element.elementor-element-a1cd467 img {
  border-radius: 24%;
}
.elementor-1652 .elementor-element.elementor-element-a1cd467 > .e-con-inner {
  border-bottom: 1px solid var(--e-global-color-ce0cfb7);
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf590592ecb6f2_THICCCBOI-Bold.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf597b00ecb6f3_THICCCBOI-Medium.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf599227ecb6f4_THICCCBOI-SemiBold.ttf)
    format("truetype");
}
@font-face {
  font-family: "thicccboi";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://planzer.io/wp-content/uploads/2022/11/62e22028e877056d28819f41_THICCCBOI-Regular.ttf)
    format("truetype");
}
/*! elementor - v3.22.0 - 26-06-2024 */
.elementor-widget-image {
  text-align: center;
}
.elementor-widget-image a {
  display: inline-block;
}
.elementor-widget-image img {
  vertical-align: middle;
  display: inline-block;
}
@keyframes hide-scroll {
  0%,
  to {
    overflow: hidden;
  }
}

/*! elementor - v3.22.0 - 26-06-2024 */

/*! elementor - v3.22.0 - 26-06-2024 */
.elementor-widget-icon-box .elementor-icon-box-wrapper {
  display: block;
  text-align: center;
}
.elementor-widget-icon-box.elementor-position-top .elementor-icon-box-wrapper {
  display: block;
  text-align: center;
  flex-direction: unset;
}
.elementor-widget-icon-box .elementor-icon-box-title a {
  color: inherit;
}
.elementor-widget-icon-box .elementor-icon-box-content {
  flex-grow: 1;
}
.elementor-widget-icon-box .elementor-icon-box-description {
  margin: 0;
}

/*! elementor - v3.22.0 - 26-06-2024 */
.elementor-widget.elementor-icon-list--layout-inline
  .elementor-widget-container {
  overflow: hidden;
}
.elementor-widget .elementor-icon-list-items.elementor-inline-items {
  /*margin-right: -8px;*/
  /*margin-left: -8px;*/
}
.elementor-widget
  .elementor-icon-list-items.elementor-inline-items
  .elementor-icon-list-item {
  margin-right: 8px;
  margin-left: 8px;
}
.elementor-widget
  .elementor-icon-list-items.elementor-inline-items
  .elementor-icon-list-item:after {
  width: auto;
  left: auto;
  right: auto;
  position: relative;
  height: 100%;
  border-top: 0;
  border-bottom: 0;
  border-right: 0;
  border-left-width: 1px;
  border-style: solid;
  right: -8px;
}
.elementor-widget .elementor-icon-list-items {
  /*list-style-type: none;*/
  /*margin: 0;*/
  /*padding: 0;*/
}
.elementor-widget .elementor-icon-list-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.elementor-widget .elementor-icon-list-item:after {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.elementor-widget .elementor-icon-list-item,
.elementor-widget .elementor-icon-list-item a {
  display: flex;
  font-size: inherit;
  align-items: var(--icon-vertical-align, center);
}
.elementor-widget .elementor-icon-list-icon + .elementor-icon-list-text {
  align-self: center;
  padding-inline-start: 5px;
}
.elementor-widget .elementor-icon-list-icon {
  display: flex;
  position: relative;
  top: var(--icon-vertical-offset, initial);
}
.elementor-widget .elementor-icon-list-icon svg {
  width: var(--e-icon-list-icon-size, 1em);
  height: var(--e-icon-list-icon-size, 1em);
}
.elementor-widget .elementor-icon-list-icon i {
  width: 1.25em;
  font-size: var(--e-icon-list-icon-size);
}
.elementor-widget.elementor-widget-icon-list .elementor-icon-list-icon {
  text-align: var(--e-icon-list-icon-align);
}
.elementor-widget.elementor-widget-icon-list .elementor-icon-list-icon svg {
  margin: var(
    --e-icon-list-icon-margin,
    0 calc(var(--e-icon-list-icon-size, 1em) * 0.25) 0 0
  );
}
.elementor-widget.elementor-list-item-link-full_width a {
  width: 100%;
}
.elementor-widget.elementor-align-left .elementor-icon-list-item,
.elementor-widget.elementor-align-left .elementor-icon-list-item a {
  justify-content: flex-start;
  text-align: left;
}
.elementor-widget.elementor-align-left .elementor-inline-items {
  justify-content: flex-start;
}
.elementor-widget.elementor-align-right .elementor-icon-list-item,
.elementor-widget.elementor-align-right .elementor-icon-list-item a {
  justify-content: flex-end;
  text-align: right;
}
.elementor-widget.elementor-align-right .elementor-icon-list-items {
  justify-content: flex-end;
}
.elementor-widget:not(.elementor-align-right) .elementor-icon-list-item:after {
  left: 0;
}
.elementor-widget:not(.elementor-align-left) .elementor-icon-list-item:after {
  right: 0;
}
@media (min-width: -1) {
  .elementor-widget:not(.elementor-widescreen-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-widescreen-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}
@media (max-width: -1) {
  .elementor-widget:not(.elementor-laptop-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-laptop-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}
@media (max-width: -1) {
  .elementor-widget:not(.elementor-tablet_extra-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-tablet_extra-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}
@media (max-width: 1024px) {
  .elementor-widget:not(.elementor-tablet-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-tablet-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}
@media (max-width: -1) {
  .elementor-widget:not(.elementor-mobile_extra-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-mobile_extra-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}
@media (max-width: 767px) {
  .elementor-widget:not(.elementor-mobile-align-right)
    .elementor-icon-list-item:after {
    left: 0;
  }
  .elementor-widget:not(.elementor-mobile-align-left)
    .elementor-icon-list-item:after {
    right: 0;
  }
}

/*! elementor - v3.22.0 - 26-06-2024 */
body.elementor-page .elementor-widget-menu-anchor {
  margin-bottom: 0;
}
/*! elementor - v3.22.0 - 26-06-2024 */
.elementor-widget-image-box .elementor-image-box-content {
  width: 100%;
}
@media (min-width: 768px) {
  .elementor-widget-image-box.elementor-position-top .elementor-image-box-img {
    margin: auto;
  }
}
@media (max-width: 767px) {
  .elementor-widget-image-box .elementor-image-box-img {
    margin-left: auto !important;
    margin-right: auto !important;
    margin-bottom: 15px;
  }
}
.elementor-widget-image-box .elementor-image-box-img {
  display: inline-block;
}
.elementor-widget-image-box .elementor-image-box-title a {
  color: inherit;
}
.elementor-widget-image-box .elementor-image-box-wrapper {
  text-align: center;
}
.elementor-widget-image-box .elementor-image-box-description {
  margin: 0;
}
/*! elementor - v3.22.0 - 26-06-2024 */
.elementor-heading-title {
  padding: 0;
  margin: 0;
  line-height: 1;
}
.elementor-widget-heading
  .elementor-heading-title[class*="elementor-size-"]
  > a {
  color: inherit;
  font-size: inherit;
  line-height: inherit;
}
/*! elementor-pro - v3.21.0 - 15-04-2024 */
/*! elementor - v3.22.0 - 26-06-2024 */

@keyframes bounce {
  20%,
  53%,
  80%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }
  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0);
  }
  90% {
    transform: translate3d(0, -4px, 0);
  }
}
@keyframes flash {
  50%,
  from,
  to {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
@keyframes pulse {
  from,
  to {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
}
@keyframes rubberBand {
  from,
  to {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
}
@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
}
@keyframes headShake {
  0% {
    transform: translateX(0);
  }
  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }
  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }
  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }
  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }
  50% {
    transform: translateX(0);
  }
}
@keyframes swing {
  20% {
    transform: rotate3d(0, 0, 1, 15deg);
  }
  40% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  60% {
    transform: rotate3d(0, 0, 1, 5deg);
  }
  80% {
    transform: rotate3d(0, 0, 1, -5deg);
  }
  to {
    transform: rotate3d(0, 0, 1, 0deg);
  }
}
@keyframes tada {
  from,
  to {
    transform: scale3d(1, 1, 1);
  }
  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }
  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }
  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }
}
@keyframes wobble {
  from,
  to {
    transform: none;
  }
  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }
  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }
  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }
  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }
  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }
}
@keyframes jello {
  11.1%,
  from,
  to {
    transform: none;
  }
  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }
  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }
  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }
  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }
  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }
  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }
  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
}
@keyframes bounceIn {
  20%,
  40%,
  60%,
  80%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
@keyframes bounceInDown {
  60%,
  75%,
  90%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceInLeft {
  60%,
  75%,
  90%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceInRight {
  60%,
  75%,
  90%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceInUp {
  60%,
  75%,
  90%,
  from,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInUp {
  animation-name: fadeInUp;
}
@keyframes lightSpeedIn {
  from {
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: skewX(20deg);
    opacity: 1;
  }
  80% {
    transform: skewX(-5deg);
    opacity: 1;
  }
  to {
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateIn {
  from {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  to {
    transform-origin: center;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateInDownLeft {
  from {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
  to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateInDownRight {
  from {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
  to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateInUpLeft {
  from {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
  to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateInUpRight {
  from {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
  }
  to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
  }
}
@keyframes rollIn {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomInDown {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
@keyframes zoomInLeft {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
@keyframes zoomInRight {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
@keyframes zoomInUp {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
@keyframes slideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slideInLeft {
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.elementor-animation-shrink {
  transition-duration: 0.3s;
  transition-property: transform;
}
.elementor-animation-shrink:active,
.elementor-animation-shrink:focus,
.elementor-animation-shrink:hover {
  transform: scale(0.9);
}
@keyframes elementor-animation-pulse {
  25% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(0.9);
  }
}
@keyframes elementor-animation-pulse-grow {
  to {
    transform: scale(1.1);
  }
}
@keyframes elementor-animation-pulse-shrink {
  to {
    transform: scale(0.9);
  }
}
@keyframes elementor-animation-push {
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes elementor-animation-pop {
  50% {
    transform: scale(1.2);
  }
}
@keyframes elementor-animation-bob {
  0% {
    transform: translateY(-8px);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(-8px);
  }
}
@keyframes elementor-animation-bob-float {
  100% {
    transform: translateY(-8px);
  }
}
@keyframes elementor-animation-hang {
  0% {
    transform: translateY(8px);
  }
  50% {
    transform: translateY(4px);
  }
  100% {
    transform: translateY(8px);
  }
}
@keyframes elementor-animation-hang-sink {
  100% {
    transform: translateY(8px);
  }
}
@keyframes elementor-animation-wobble-vertical {
  16.65% {
    transform: translateY(8px);
  }
  33.3% {
    transform: translateY(-6px);
  }
  49.95% {
    transform: translateY(4px);
  }
  66.6% {
    transform: translateY(-2px);
  }
  83.25% {
    transform: translateY(1px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes elementor-animation-wobble-horizontal {
  16.65% {
    transform: translateX(8px);
  }
  33.3% {
    transform: translateX(-6px);
  }
  49.95% {
    transform: translateX(4px);
  }
  66.6% {
    transform: translateX(-2px);
  }
  83.25% {
    transform: translateX(1px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes elementor-animation-wobble-to-bottom-right {
  16.65% {
    transform: translate(8px, 8px);
  }
  33.3% {
    transform: translate(-6px, -6px);
  }
  49.95% {
    transform: translate(4px, 4px);
  }
  66.6% {
    transform: translate(-2px, -2px);
  }
  83.25% {
    transform: translate(1px, 1px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes elementor-animation-wobble-to-top-right {
  16.65% {
    transform: translate(8px, -8px);
  }
  33.3% {
    transform: translate(-6px, 6px);
  }
  49.95% {
    transform: translate(4px, -4px);
  }
  66.6% {
    transform: translate(-2px, 2px);
  }
  83.25% {
    transform: translate(1px, -1px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes elementor-animation-wobble-top {
  16.65% {
    transform: skew(-12deg);
  }
  33.3% {
    transform: skew(10deg);
  }
  49.95% {
    transform: skew(-6deg);
  }
  66.6% {
    transform: skew(4deg);
  }
  83.25% {
    transform: skew(-2deg);
  }
  100% {
    transform: skew(0);
  }
}
@keyframes elementor-animation-wobble-bottom {
  16.65% {
    transform: skew(-12deg);
  }
  33.3% {
    transform: skew(10deg);
  }
  49.95% {
    transform: skew(-6deg);
  }
  66.6% {
    transform: skew(4deg);
  }
  83.25% {
    transform: skew(-2deg);
  }
  100% {
    transform: skew(0);
  }
}
@keyframes elementor-animation-wobble-skew {
  16.65% {
    transform: skew(-12deg);
  }
  33.3% {
    transform: skew(10deg);
  }
  49.95% {
    transform: skew(-6deg);
  }
  66.6% {
    transform: skew(4deg);
  }
  83.25% {
    transform: skew(-2deg);
  }
  100% {
    transform: skew(0);
  }
}
@keyframes elementor-animation-buzz {
  50% {
    transform: translateX(3px) rotate(2deg);
  }
  100% {
    transform: translateX(-3px) rotate(-2deg);
  }
}
@keyframes elementor-animation-buzz-out {
  10% {
    transform: translateX(3px) rotate(2deg);
  }
  20% {
    transform: translateX(-3px) rotate(-2deg);
  }
  30% {
    transform: translateX(3px) rotate(2deg);
  }
  40% {
    transform: translateX(-3px) rotate(-2deg);
  }
  50% {
    transform: translateX(2px) rotate(1deg);
  }
  60% {
    transform: translateX(-2px) rotate(-1deg);
  }
  70% {
    transform: translateX(2px) rotate(1deg);
  }
  80% {
    transform: translateX(-2px) rotate(-1deg);
  }
  90% {
    transform: translateX(1px) rotate(0);
  }
  100% {
    transform: translateX(-1px) rotate(0);
  }
}
.elementor-1770 .elementor-element.elementor-element-43c693e0 {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: initial;
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --background-transition: 0.3s;
  --border-radius: 50px 50px 50px 50px;
  --padding-top: 110px;
  --padding-bottom: 135px;
  --padding-left: 54px;
  --padding-right: 54px;
}
.elementor-1770
  .elementor-element.elementor-element-43c693e0:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.elementor-1770 .elementor-element.elementor-element-43c693e0,
.elementor-1770 .elementor-element.elementor-element-43c693e0::before {
  --border-transition: 0.3s;
}
.elementor-1770
  .elementor-element.elementor-element-75867125
  .elementor-heading-title {
  color: var(--e-global-color-0b8b4d2);
  font-family: "thicccboi", Sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.3em;
}
.elementor-1770 .elementor-element.elementor-element-75867125 {
  width: var(--container-widget-width, 50%);
  max-width: 50%;
  --container-widget-width: 50%;
  --container-widget-flex-grow: 0;
}
.elementor-1770
  .elementor-element.elementor-element-58fe34d3
  .elementor-button {
  font-size: 22px;
  font-weight: 700;
  fill: var(--e-global-color-accent);
  color: var(--e-global-color-accent);
  background-color: var(--e-global-color-0b8b4d2);
  border-radius: 18px 18px 18px 18px;
  padding: 36px 36px 36px 36px;
}
.elementor-1770 .elementor-element.elementor-element-58fe34d3 {
  width: var(--container-widget-width, 50%);
  max-width: 50%;
  --container-widget-width: 50%;
  --container-widget-flex-grow: 0;
}
.elementor-1770
  .elementor-element.elementor-element-58fe34d3.elementor-element {
  --align-self: center;
}
@media (max-width: 1024px) {
  .elementor-1770 .elementor-element.elementor-element-43c693e0 {
    --padding-top: 100px;
    --padding-bottom: 100px;
    --padding-left: 40px;
    --padding-right: 40px;
  }
  .elementor-1770
    .elementor-element.elementor-element-75867125
    .elementor-heading-title {
    font-size: 30px;
  }
  .elementor-1770
    .elementor-element.elementor-element-58fe34d3
    .elementor-button {
    padding: 25px 25px 25px 25px;
  }
}
@media (max-width: 767px) {
  .elementor-1770 .elementor-element.elementor-element-43c693e0 {
    --border-radius: 30px 30px 30px 30px;
    --padding-top: 50px;
    --padding-bottom: 50px;
    --padding-left: 30px;
    --padding-right: 30px;
  }
  .elementor-1770
    .elementor-element.elementor-element-75867125
    .elementor-heading-title {
    font-size: 26px;
    line-height: 1.2em;
  }
  .elementor-1770
    .elementor-element.elementor-element-75867125
    > .elementor-widget-container {
    margin: 0 0 15px 0;
  }
  .elementor-1770 .elementor-element.elementor-element-75867125 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
  .elementor-1770
    .elementor-element.elementor-element-58fe34d3
    .elementor-button {
    font-size: 18px;
    padding: 20px 20px 20px 20px;
  }
  .elementor-1770 .elementor-element.elementor-element-58fe34d3 {
    --container-widget-width: 100%;
    --container-widget-flex-grow: 0;
    width: var(--container-widget-width, 100%);
    max-width: 100%;
  }
}
.elementor-1566 .elementor-element.elementor-element-633576a6 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
  --margin-top: 80px;
  --margin-bottom: 120px;
  --margin-left: 0px;
  --margin-right: 0px;
}
.elementor-1566 .elementor-element.elementor-element-2a4fb96c {
  --display: flex;
  --flex-direction: row;
  --container-widget-width: initial;
  --container-widget-height: 100%;
  --container-widget-flex-grow: 1;
  --container-widget-align-self: stretch;
  --background-transition: 0.3s;
  --border-radius: 50px 50px 50px 50px;
  --padding-top: 50px;
  --padding-bottom: 50px;
  --padding-left: 50px;
  --padding-right: 50px;
}
.elementor-1566
  .elementor-element.elementor-element-2a4fb96c:not(
    .elementor-motion-effects-element-type-background
  ) {
  background-color: var(--e-global-color-accent);
}
.elementor-1566 .elementor-element.elementor-element-2a4fb96c,
.elementor-1566 .elementor-element.elementor-element-2a4fb96c::before {
  --border-transition: 0.3s;
}
.elementor-1566 .elementor-element.elementor-element-672681a4 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --justify-content: center;
  --background-transition: 0.3s;
}
.elementor-1566
  .elementor-element.elementor-element-79038120
  .elementor-heading-title {
  color: #fff;
}
.elementor-1566
  .elementor-element.elementor-element-30942c0e
  .elementor-button {
  font-size: 18px;
  font-weight: 600;
  fill: var(--e-global-color-accent);
  color: var(--e-global-color-accent);
  background-color: var(--e-global-color-0b8b4d2);
}
.elementor-1566
  .elementor-element.elementor-element-30942c0e
  .elementor-button:hover,
.elementor-1566
  .elementor-element.elementor-element-30942c0e
  .elementor-button:focus {
  color: var(--e-global-color-0b8b4d2);
  background-color: var(--e-global-color-inverse_primary);
}
.elementor-1566
  .elementor-element.elementor-element-30942c0e
  .elementor-button:hover
  svg,
.elementor-1566
  .elementor-element.elementor-element-30942c0e
  .elementor-button:focus
  svg {
  fill: var(--e-global-color-0b8b4d2);
}
.elementor-1566 .elementor-element.elementor-element-2e0d5022 {
  --display: flex;
  --flex-direction: column;
  --container-widget-width: 100%;
  --container-widget-height: initial;
  --container-widget-flex-grow: 0;
  --container-widget-align-self: initial;
  --background-transition: 0.3s;
}
.elementor-1566 .elementor-element.elementor-element-71772c73 img {
  width: 100%;
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 25px 25px 25px 25px;
}
body:not(.rtl) .elementor-1566 .elementor-element.elementor-element-71772c73 {
  left: 0%;
}
.elementor-1566 .elementor-element.elementor-element-71772c73 {
  bottom: 10%;
}
.elementor-1566 .elementor-element.elementor-element-60ddee1b {
  text-align: right;
}
.elementor-1566 .elementor-element.elementor-element-60ddee1b img {
  width: 80%;
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eff0f6;
  border-radius: 25px 25px 25px 25px;
  box-shadow: 0 -6px 24px 0 rgb(0 0 0 / 0.07);
}
.elementor-1566
  .elementor-element.elementor-element-60ddee1b
  > .elementor-widget-container {
  margin: -100px 0 0 0;
}
@media (max-width: 1024px) {
  .elementor-1566
    .elementor-element.elementor-element-30942c0e
    .elementor-button {
    font-size: 16px;
  }
  .elementor-1566 .elementor-element.elementor-element-71772c73 img {
    width: 162px;
  }
  .elementor-1566 .elementor-element.elementor-element-60ddee1b img {
    width: 100%;
  }
  .elementor-1566
    .elementor-element.elementor-element-60ddee1b
    > .elementor-widget-container {
    margin: -100px 0 0 0;
  }
}
@media (max-width: 767px) {
  .elementor-1566 .elementor-element.elementor-element-633576a6 {
    --margin-top: 40px;
    --margin-bottom: 100px;
    --margin-left: 0px;
    --margin-right: 0px;
  }
  .elementor-1566 .elementor-element.elementor-element-2a4fb96c {
    --border-radius: 30px 30px 30px 30px;
    --padding-top: 30px;
    --padding-bottom: 40px;
    --padding-left: 25px;
    --padding-right: 25px;
  }
  .elementor-1566 .elementor-element.elementor-element-2e0d5022 {
    --padding-top: 0px;
    --padding-bottom: 0px;
    --padding-left: 0px;
    --padding-right: 0px;
  }
  .elementor-1566
    .elementor-element.elementor-element-60ddee1b
    > .elementor-widget-container {
    margin: 0 0 0 0;
  }
}
@media (min-width: 768px) {
  .elementor-1566 .elementor-element.elementor-element-672681a4 {
    --width: 50%;
  }
  .elementor-1566 .elementor-element.elementor-element-2e0d5022 {
    --width: 50%;
  }
}
.elementor-1566 .elementor-element.elementor-element-71772c73 {
  box-shadow: 0 34px 87px 0 rgb(32 36 138 / 9%);
}
.elementor-1566 .elementor-element.elementor-element-60ddee1b {
  box-shadow: 0 3px 28px 0 rgb(32 36 138 / 6%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/products-styling/cleaned/product.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C,gBAAgB;;AAEhB,iCAAiC;;;;AAIjC,sCAAsC;AACtC;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;EAKE,SAAS;AACX;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,8DAA8D;EAC9D,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yDAAyD;EACzD,6DAA6D;EAC7D,+DAA+D;EAC/D,2DAA2D;EAC3D,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,iCAAiC;EACjC,oBAAoB;EACpB,0BAA0B;EAC1B,6CAA6C;EAC7C,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,mCAAmC;EACnC,uBAAuB;EACvB,yBAAyB;EACzB;;;8DAG4D;EAC5D,wBAAwB;EACxB,6CAA6C;EAC7C,2CAA2C;EAC3C,yCAAyC;EACzC,+CAA+C;EAC/C,iDAAiD;EACjD,6CAA6C;EAC7C,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,mDAAmD;EACnD,oDAAoD;EACpD,qDAAqD;EACrD,oDAAoD;AACtD;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2DAA2D;AAC7D;AACA;;EAEE,6BAA6B;EAC7B,+CAA+C;EAC/C,2CAA2C;AAC7C;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,+BAA+B;EAC/B,2CAA2C;EAC3C,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,yDAAyD;EACzD,uDAAuD;EACvD,qDAAqD;EACrD,2DAA2D;EAC3D,wCAAwC;EACxC,0CAA0C;EAC1C,6EAA6E;EAC7E;;;GAGC;AACH;AACA;EACE;;2CAEyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;EACE;IACE,aAAa;IACb,oCAAoC;EACtC;AACF;AACA;EACE;0DACwD;AAC1D;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,oCAAoC;EACpC,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,gCAAgC;EAChC,yCAAyC;EACzC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,sDAAsD;EACtD,+CAA+C;EAC/C,8CAA8C;EAC9C,gDAAgD;EAChD,wDAAwD;EACxD,mDAAmD;EACnD,8CAA8C;EAC9C,2CAA2C;EAC3C,8CAA8C;EAC9C,qDAAqD;EACrD,gDAAgD;EAChD,6CAA6C;EAC7C,gDAAgD;EAChD,8DAA8D;EAC9D,sDAAsD;EACtD,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,sDAAsD;EACtD,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;AACA;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,uEAAuE;EACvE,uDAAuD;EACvD,2DAA2D;EAC3D,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;AAC/D;AACA;EACE,4CAA4C;EAC5C,uEAAuE;EACvE,uDAAuD;EACvD,2DAA2D;EAC3D,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;AAC/D;AACA;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,8CAA8C;EAC9C,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;;;;EAIE,WAAW;EACX,uDAAuD;AACzD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,uDAAuD;IACvD,2DAA2D;IAC3D,iEAAiE;IACjE,6DAA6D;EAC/D;EACA;IACE,uDAAuD;IACvD,2DAA2D;IAC3D,iEAAiE;IACjE,6DAA6D;EAC/D;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,0CAA0C;IAC1C,6CAA6C;IAC7C,gDAAgD;IAChD,eAAe;EACjB;EACA;IACE,uDAAuD;IACvD,2DAA2D;IAC3D,iEAAiE;IACjE,6DAA6D;EAC/D;EACA;IACE,uDAAuD;IACvD,2DAA2D;IAC3D,iEAAiE;IACjE,6DAA6D;EAC/D;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;;AAEA;;;;;;;;;;EAUE;AACF;EACE,yBAAyB;EACzB,4CAA6rE;EAC7rE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,wBAAwB;EACxB;;GAEC;EACD,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,+CAA+C;AACjD;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,aAAa;EACb,2CAA2C;AAC7C;AACA;;;;;;;EAOE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;;;;EAIE,8BAA8B;AAChC;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;EAIE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;;EAGE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;;;;EAKE,sBAAsB;AACxB;AACA;;;;EAIE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;;;;EAIE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;;;;;EAKE,oCAAoC;AACtC;AACA;;;;;EAKE,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;;;EAGE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;;;;EAIE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,+CAA+C;AACjD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,kCAAkC;EAClC;0DACwD;AAC1D;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;;;;EAIE,+CAA+C;AACjD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,+CAA+C;AACjD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,kCAAkC;EAClC;0DACwD;AAC1D;AACA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB;;GAEC;EACD,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2DAA2D;AAC7D;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;;;;;;;;;IASE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;;;;;IAOE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,4BAA4B;EAC9B;AACF;AACA;EACE;;;;;;;;;IASE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;;;;;IAOE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;AACF;AACA;;;;EAIE,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB;yEACuE;EACvE,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sBACoB;AACtB;AACA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;;AAEtC,sCAAsC;AACtC;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;;AAEA,sCAAsC;AACtC;;EAEE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;;;GAGC;AACH;AACA;EACE,WAAW;AACb;AACA;;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;AACA;EACE;;IAEE,OAAO;EACT;EACA;;IAEE,QAAQ;EACV;AACF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,WAAW;AACb;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA,sCAAsC;AACtC;EACE,UAAU;EACV,SAAS;EACT,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA,0CAA0C;AAC1C,sCAAsC;;AAEtC;EACE;;;;;IAKE,8DAA8D;IAC9D,+BAA+B;EACjC;EACA;;IAEE,iEAAiE;IACjE,mCAAmC;EACrC;EACA;IACE,iEAAiE;IACjE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;AACF;AACA;EACE;;;IAGE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE;;IAEE,+BAA+B;EACjC;EACA;;;;;IAKE,mCAAmC;EACrC;EACA;;;;IAIE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;AACF;AACA;EACE;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,0DAA0D;EAC5D;EACA;;;;IAIE,yDAAyD;EAC3D;EACA;;;IAGE,0DAA0D;EAC5D;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,0DAA0D;EAC5D;AACF;AACA;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE;;;;;;IAME,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;AACA;EACE;;;;;IAKE,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;;;;;IAKE,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;;;;;IAKE,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;;;;;IAKE,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,gDAAgD;IAChD,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,wBAAwB;IACxB,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,mCAAmC;IACnC,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,mCAAmC;IACnC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,8BAA8B;IAC9B,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,4DAA4D;IAC5D,iEAAiE;EACnE;EACA;IACE,UAAU;IACV,+DAA+D;IAC/D,8DAA8D;EAChE;AACF;AACA;EACE;IACE,UAAU;IACV,4DAA4D;IAC5D,iEAAiE;EACnE;EACA;IACE,UAAU;IACV,+DAA+D;IAC/D,8DAA8D;EAChE;AACF;AACA;EACE;IACE,UAAU;IACV,2DAA2D;IAC3D,iEAAiE;EACnE;EACA;IACE,UAAU;IACV,gEAAgE;IAChE,8DAA8D;EAChE;AACF;AACA;EACE;IACE,UAAU;IACV,2DAA2D;IAC3D,iEAAiE;EACnE;EACA;IACE,UAAU;IACV,gEAAgE;IAChE,8DAA8D;EAChE;AACF;AACA;EACE;IACE,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;;EAIE,yDAAkM;EAClM,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,oCAAoC;EACpC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,+CAA+C;EAC/C,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,oCAAoC;IACpC,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;;EAIE,8CAA8C;AAChD;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;;;EAGE,WAAW;AACb;AACA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,+CAA+C;AACjD;AACA;;;;;;EAME,oCAAoC;EACpC,uDAAuD;AACzD;AACA;;;;;;;;EAQE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;;IAGE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;;;IAGE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C","sourcesContent":["/*! elementor-pro - v3.21.0 - 15-04-2024 */\n@charset \"UTF-8\";\n\n/*! This file is auto-generated */\n\n\n\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor *,\n.elementor :after,\n.elementor :before {\n  box-sizing: border-box;\n}\n.elementor a {\n  box-shadow: none;\n  text-decoration: none;\n}\n.elementor img {\n  height: auto;\n  max-width: 100%;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n.elementor\n  .elementor-widget:not(.elementor-widget-text-editor):not(\n    .elementor-widget-theme-post-content\n  )\n  figure {\n  margin: 0;\n}\n.e-con-inner > .elementor-element.elementor-absolute,\n.e-con > .elementor-element.elementor-absolute {\n  position: absolute;\n}\n.elementor-element {\n  --flex-direction: initial;\n  --flex-wrap: initial;\n  --justify-content: initial;\n  --align-items: initial;\n  --align-content: initial;\n  --gap: initial;\n  --flex-basis: initial;\n  --flex-grow: initial;\n  --flex-shrink: initial;\n  --order: initial;\n  --align-self: initial;\n  flex-basis: var(--flex-basis);\n  flex-grow: var(--flex-grow);\n  flex-shrink: var(--flex-shrink);\n  order: var(--order);\n  align-self: var(--align-self);\n}\n.elementor-element.elementor-absolute {\n  z-index: 1;\n}\n.elementor-element:where(.e-con-full, .elementor-widget) {\n  flex-direction: var(--flex-direction);\n  flex-wrap: var(--flex-wrap);\n  justify-content: var(--justify-content);\n  align-items: var(--align-items);\n  align-content: var(--align-content);\n  gap: var(--gap);\n}\n.elementor-invisible {\n  visibility: hidden;\n}\n.elementor-align-right {\n  text-align: right;\n}\n.elementor-align-right .elementor-button {\n  width: auto;\n}\n.elementor-align-left {\n  text-align: left;\n}\n.elementor-align-left .elementor-button {\n  width: auto;\n}\n@media (max-width: 767px) {\n  .elementor-mobile-align-justify .elementor-button {\n    width: 100%;\n  }\n}\n:root {\n  --page-title-display: block;\n}\n@keyframes eicon-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n.elementor-widget {\n  position: relative;\n}\n.elementor-widget:not(:last-child) {\n  margin-bottom: 20px;\n}\n.elementor-widget:not(:last-child).elementor-absolute,\n.elementor-widget:not(:last-child).elementor-widget__width-initial {\n  margin-bottom: 0;\n}\nul.elementor-icon-list-items.elementor-inline-items {\n  display: flex;\n  flex-wrap: wrap;\n}\nul.elementor-icon-list-items.elementor-inline-items .elementor-inline-item {\n  word-break: break-word;\n}\n.e-con {\n  --border-radius: 0;\n  --border-top-width: 0px;\n  --border-right-width: 0px;\n  --border-bottom-width: 0px;\n  --border-left-width: 0px;\n  --border-style: initial;\n  --border-color: initial;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --content-width: min(100%, var(--container-max-width, 1140px));\n  --width: 100%;\n  --min-height: initial;\n  --height: auto;\n  --text-align: initial;\n  --margin-top: 0px;\n  --margin-right: 0px;\n  --margin-bottom: 0px;\n  --margin-left: 0px;\n  --padding-top: var(--container-default-padding-top, 10px);\n  --padding-right: var(--container-default-padding-right, 10px);\n  --padding-bottom: var(--container-default-padding-bottom, 10px);\n  --padding-left: var(--container-default-padding-left, 10px);\n  --position: relative;\n  --z-index: revert;\n  --overflow: visible;\n  --gap: var(--widgets-spacing, 20px);\n  --overlay-mix-blend-mode: initial;\n  --overlay-opacity: 1;\n  --overlay-transition: 0.3s;\n  --e-con-grid-template-columns: repeat(3, 1fr);\n  --e-con-grid-template-rows: repeat(2, 1fr);\n  position: var(--position);\n  width: var(--width);\n  min-width: 0;\n  min-height: var(--min-height);\n  height: var(--height);\n  border-radius: var(--border-radius);\n  z-index: var(--z-index);\n  overflow: var(--overflow);\n  transition: background var(--background-transition, 0.3s),\n    border var(--border-transition, 0.3s),\n    box-shadow var(--border-transition, 0.3s),\n    transform var(--e-con-transform-transition-duration, 0.4s);\n  --flex-wrap-mobile: wrap;\n  margin-block-start: var(--margin-block-start);\n  margin-inline-end: var(--margin-inline-end);\n  margin-block-end: var(--margin-block-end);\n  margin-inline-start: var(--margin-inline-start);\n  padding-inline-start: var(--padding-inline-start);\n  padding-inline-end: var(--padding-inline-end);\n  --margin-block-start: var(--margin-top);\n  --margin-block-end: var(--margin-bottom);\n  --margin-inline-start: var(--margin-left);\n  --margin-inline-end: var(--margin-right);\n  --padding-inline-start: var(--padding-left);\n  --padding-inline-end: var(--padding-right);\n  --padding-block-start: var(--padding-top);\n  --padding-block-end: var(--padding-bottom);\n  --border-block-start-width: var(--border-top-width);\n  --border-block-end-width: var(--border-bottom-width);\n  --border-inline-start-width: var(--border-left-width);\n  --border-inline-end-width: var(--border-right-width);\n}\n.e-con.e-flex {\n  --flex-direction: column;\n  --flex-basis: auto;\n  --flex-grow: 0;\n  --flex-shrink: 1;\n  flex: var(--flex-grow) var(--flex-shrink) var(--flex-basis);\n}\n.e-con-full,\n.e-con > .e-con-inner {\n  text-align: var(--text-align);\n  padding-block-start: var(--padding-block-start);\n  padding-block-end: var(--padding-block-end);\n}\n.e-con-full.e-flex,\n.e-con.e-flex > .e-con-inner {\n  flex-direction: var(--flex-direction);\n}\n.e-con,\n.e-con > .e-con-inner {\n  display: var(--display);\n}\n.e-con-boxed.e-flex {\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: normal;\n  align-items: normal;\n  align-content: normal;\n}\n.e-con-boxed {\n  text-align: initial;\n  gap: initial;\n}\n.e-con.e-flex > .e-con-inner {\n  flex-wrap: var(--flex-wrap);\n  justify-content: var(--justify-content);\n  align-items: var(--align-items);\n  align-content: var(--align-content);\n  flex-basis: auto;\n  flex-grow: 1;\n  flex-shrink: 1;\n  align-self: auto;\n}\n.e-con > .e-con-inner {\n  gap: var(--gap);\n  width: 100%;\n  max-width: var(--content-width);\n  margin: 0 auto;\n  padding-inline-start: 0;\n  padding-inline-end: 0;\n  height: 100%;\n}\n:is( [data-elementor-id]) > .e-con {\n  --margin-left: auto;\n  --margin-right: auto;\n  max-width: min(100%, var(--width));\n}\n.e-con .elementor-widget.elementor-widget {\n  margin-block-end: 0;\n}\n.e-con:before {\n  content: var(--background-overlay);\n  display: block;\n  position: absolute;\n  mix-blend-mode: var(--overlay-mix-blend-mode);\n  opacity: var(--overlay-opacity);\n  transition: var(--overlay-transition, 0.3s);\n  border-radius: var(--border-radius);\n  border-style: var(--border-style);\n  border-color: var(--border-color);\n  border-block-start-width: var(--border-block-start-width);\n  border-inline-end-width: var(--border-inline-end-width);\n  border-block-end-width: var(--border-block-end-width);\n  border-inline-start-width: var(--border-inline-start-width);\n  top: calc(0px - var(--border-top-width));\n  left: calc(0px - var(--border-left-width));\n  width: max(100% + var(--border-left-width) + var(--border-right-width), 100%);\n  height: max(\n    100% + var(--border-top-width) + var(--border-bottom-width),\n    100%\n  );\n}\n.e-con:before {\n  transition: background var(--overlay-transition, 0.3s),\n    border-radius var(--border-transition, 0.3s),\n    opacity var(--overlay-transition, 0.3s);\n}\n.e-con .elementor-widget {\n  min-width: 0;\n}\n.e-con > .e-con-inner > .elementor-widget > .elementor-widget-container,\n.e-con > .elementor-widget > .elementor-widget-container {\n  height: 100%;\n}\n.e-con.e-con > .e-con-inner > .elementor-widget,\n.elementor.elementor .e-con > .elementor-widget {\n  max-width: 100%;\n}\n@media (max-width: 767px) {\n  .e-con.e-flex {\n    --width: 100%;\n    --flex-wrap: var(--flex-wrap-mobile);\n  }\n}\n.elementor-element .elementor-widget-container {\n  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s,\n    transform var(--e-transform-transition-duration, 0.4s);\n}\n.elementor-button {\n  display: inline-block;\n  line-height: 1;\n  background-color: #69727d;\n  font-size: 15px;\n  padding: 12px 24px;\n  border-radius: 3px;\n  color: #fff;\n  fill: #fff;\n  text-align: center;\n  transition: all 0.3s;\n}\n.elementor-button:focus,\n.elementor-button:hover,\n.elementor-button:visited {\n  color: #fff;\n}\n.elementor-button-content-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  gap: 5px;\n}\n.elementor-button-icon svg {\n  width: 1em;\n  height: auto;\n}\n.elementor-button-text {\n  display: inline-block;\n}\n.elementor-button span {\n  text-decoration: inherit;\n}\n.elementor-element {\n  --swiper-theme-color: #000;\n  --swiper-navigation-size: 44px;\n  --swiper-pagination-bullet-size: 6px;\n  --swiper-pagination-bullet-horizontal-gap: 6px;\n}\n.elementor-shape {\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  line-height: 0;\n  direction: ltr;\n}\n.elementor-shape-bottom {\n  bottom: -1px;\n}\n.elementor-shape-bottom:not([data-negative=\"true\"]) svg {\n  z-index: -1;\n}\n.elementor-shape[data-negative=\"false\"].elementor-shape-bottom {\n  transform: rotate(180deg);\n}\n.elementor-shape svg {\n  display: block;\n  width: calc(100% + 1.3px);\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.elementor-shape .elementor-shape-fill {\n  fill: #fff;\n  transform-origin: center;\n  transform: rotateY(0deg);\n}\n\n.elementor .elementor-element ul.elementor-icon-list-items {\n  padding: 0;\n}\n\n@keyframes e-contact-buttons-typing-jump {\n  0% {\n    bottom: 0;\n  }\n  20% {\n    bottom: 5px;\n  }\n  40% {\n    bottom: 0;\n  }\n}\n@keyframes e-contact-buttons-appear {\n  0% {\n    height: 0;\n    opacity: 0;\n    visibility: hidden;\n  }\n  to {\n    height: auto;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@keyframes e-contact-buttons-disappear {\n  0% {\n    display: inline-flex;\n  }\n  to {\n    display: none;\n  }\n}\n@keyframes e-contact-buttons-close {\n  0%,\n  99.99% {\n    visibility: visible;\n    opacity: 1;\n  }\n  to {\n    visibility: hidden;\n    opacity: 0;\n    transform: none;\n  }\n}\n.elementor-kit-159 {\n  --e-global-color-primary: #7a7d9c;\n  --e-global-color-secondary: #54595f;\n  --e-global-color-text: #7a7d9c;\n  --e-global-color-accent: #5335d9;\n  --e-global-color-inverse_primary: #0b0a33;\n  --e-global-color-6545aeb: #f2f5ff;\n  --e-global-color-0b8b4d2: #ffffff;\n  --e-global-color-ce0cfb7: #d9dbe9;\n  --e-global-typography-primary-font-family: \"thicccboi\";\n  --e-global-typography-primary-font-size: 2.5rem;\n  --e-global-typography-primary-font-weight: 700;\n  --e-global-typography-primary-line-height: 1.4em;\n  --e-global-typography-secondary-font-family: \"thicccboi\";\n  --e-global-typography-text-font-family: \"thicccboi\";\n  --e-global-typography-text-font-size: 1.125rem;\n  --e-global-typography-text-font-weight: 500;\n  --e-global-typography-text-line-height: 1.58em;\n  --e-global-typography-accent-font-family: \"thicccboi\";\n  --e-global-typography-accent-font-size: 1.125rem;\n  --e-global-typography-accent-font-weight: 700;\n  --e-global-typography-accent-line-height: 1.11em;\n  --e-global-typography-inverse_primary-font-family: \"thicccboi\";\n  --e-global-typography-e9e97e1-font-family: \"thicccboi\";\n  --e-global-typography-e9e97e1-font-size: 40px;\n  --e-global-typography-e9e97e1-font-weight: 700;\n  --e-global-typography-e9e97e1-line-height: 1.3em;\n  --e-global-typography-d2ffb97-font-family: \"thicccboi\";\n  --e-global-typography-d2ffb97-font-size: 28px;\n  --e-global-typography-d2ffb97-font-weight: 700;\n  --e-global-typography-d2ffb97-line-height: 1.3em;\n  color: var(--e-global-color-text);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 1.25rem;\n  font-weight: 500;\n  line-height: 1.667em;\n}\n.elementor-kit-159 p {\n  margin-bottom: 24px;\n}\n.elementor-kit-159 a {\n  color: var(--e-global-color-inverse_primary);\n}\n.elementor-kit-159 a:hover {\n  color: #4457ff;\n}\n.elementor-kit-159 h1 {\n  color: var(--e-global-color-inverse_primary);\n  letter-spacing: -0.01em;\n}\n.elementor-kit-159 h2 {\n  color: var(--e-global-color-inverse_primary);\n  font-family: var(--e-global-typography-e9e97e1-font-family), Sans-serif;\n  font-size: var(--e-global-typography-e9e97e1-font-size);\n  font-weight: var(--e-global-typography-e9e97e1-font-weight);\n  line-height: var(--e-global-typography-e9e97e1-line-height);\n  letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);\n  word-spacing: var(--e-global-typography-e9e97e1-word-spacing);\n}\n.elementor-kit-159 h3 {\n  color: var(--e-global-color-inverse_primary);\n  font-family: var(--e-global-typography-d2ffb97-font-family), Sans-serif;\n  font-size: var(--e-global-typography-d2ffb97-font-size);\n  font-weight: var(--e-global-typography-d2ffb97-font-weight);\n  line-height: var(--e-global-typography-d2ffb97-line-height);\n  letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);\n  word-spacing: var(--e-global-typography-d2ffb97-word-spacing);\n}\n.elementor-kit-159 button,\n.elementor-kit-159 .elementor-button {\n  font-family: \"thicccboi\", Sans-serif;\n  color: var(--e-global-color-0b8b4d2);\n  background-color: var(--e-global-color-accent);\n  border-radius: 50px 50px 50px 50px;\n  padding: 22px 42px 22px 42px;\n}\n.elementor-kit-159 button:hover,\n.elementor-kit-159 button:focus,\n.elementor-kit-159 .elementor-button:hover,\n.elementor-kit-159 .elementor-button:focus {\n  color: #fff;\n  background-color: var(--e-global-color-inverse_primary);\n}\n.e-con {\n  --container-max-width: 1140px;\n}\n.elementor-widget:not(:last-child) {\n  margin-block-end: 20px;\n}\n.elementor-element {\n  --widgets-spacing: 20px 20px;\n}\n@media (max-width: 1024px) {\n  .elementor-kit-159 {\n    --e-global-typography-e9e97e1-font-size: 30px;\n  }\n  .elementor-kit-159 h2 {\n    font-size: var(--e-global-typography-e9e97e1-font-size);\n    line-height: var(--e-global-typography-e9e97e1-line-height);\n    letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);\n    word-spacing: var(--e-global-typography-e9e97e1-word-spacing);\n  }\n  .elementor-kit-159 h3 {\n    font-size: var(--e-global-typography-d2ffb97-font-size);\n    line-height: var(--e-global-typography-d2ffb97-line-height);\n    letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);\n    word-spacing: var(--e-global-typography-d2ffb97-word-spacing);\n  }\n  .e-con {\n    --container-max-width: 1024px;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-kit-159 {\n    --e-global-typography-text-font-size: 1rem;\n    --e-global-typography-e9e97e1-font-size: 26px;\n    --e-global-typography-e9e97e1-line-height: 1.2em;\n    font-size: 1rem;\n  }\n  .elementor-kit-159 h2 {\n    font-size: var(--e-global-typography-e9e97e1-font-size);\n    line-height: var(--e-global-typography-e9e97e1-line-height);\n    letter-spacing: var(--e-global-typography-e9e97e1-letter-spacing);\n    word-spacing: var(--e-global-typography-e9e97e1-word-spacing);\n  }\n  .elementor-kit-159 h3 {\n    font-size: var(--e-global-typography-d2ffb97-font-size);\n    line-height: var(--e-global-typography-d2ffb97-line-height);\n    letter-spacing: var(--e-global-typography-d2ffb97-letter-spacing);\n    word-spacing: var(--e-global-typography-d2ffb97-word-spacing);\n  }\n  .e-con {\n    --container-max-width: 767px;\n  }\n}\n.elementor-animation-shrink {\n  transform: scale3d(1, 1, 1.01) !important;\n}\n.elementor-animation-shrink:hover {\n  transform: scale3d(0.95, 0.95, 1.01) !important;\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf590592ecb6f2_THICCCBOI-Bold.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf597b00ecb6f3_THICCCBOI-Medium.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf599227ecb6f4_THICCCBOI-SemiBold.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62e22028e877056d28819f41_THICCCBOI-Regular.ttf)\n    format(\"truetype\");\n}\n\n/**\n * Swiper 8.4.5\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2022 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: November 21, 2022\n */\n@font-face {\n  font-family: swiper-icons;\n  src: url(\"data:application/font-woff;charset=utf-8;base64, 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\");\n  font-weight: 400;\n  font-style: normal;\n}\n:root {\n  --swiper-theme-color: #007aff;\n}\n:root {\n  --swiper-navigation-size: 44px;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*! elementor-pro - v3.21.0 - 15-04-2024 */\n.elementor-1652 .elementor-element.elementor-element-df61ea6 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --align-items: center;\n  --background-transition: 0.3s;\n  --padding-top: 110px;\n  --padding-bottom: 220px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-df61ea6:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-color: var(--e-global-color-6545aeb);\n}\n.elementor-1652 .elementor-element.elementor-element-df61ea6,\n.elementor-1652 .elementor-element.elementor-element-df61ea6::before {\n  --border-transition: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-df61ea6\n  > .elementor-shape-bottom\n  svg,\n.elementor-1652\n  .elementor-element.elementor-element-df61ea6\n  > .e-con-inner\n  > .elementor-shape-bottom\n  svg {\n  height: 180px;\n  transform: translateX(-50%) rotateY(180deg);\n}\n.elementor-1652\n  .elementor-element.elementor-element-287395a\n  .elementor-icon-box-title,\n.elementor-1652\n  .elementor-element.elementor-element-287395a\n  .elementor-icon-box-title\n  a {\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 58px;\n  font-weight: 700;\n  line-height: 1.3em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-287395a\n  .elementor-icon-box-description {\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 1.125rem;\n  font-weight: 500;\n  line-height: 1.667em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-287395a\n  > .elementor-widget-container {\n  margin: 0 0 30px 0;\n}\n.elementor-1652 .elementor-element.elementor-element-287395a {\n  width: var(--container-widget-width, 610px);\n  max-width: 610px;\n  --container-widget-width: 610px;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-items:not(.elementor-inline-items)\n  .elementor-icon-list-item:not(:last-child) {\n  padding-bottom: calc(25px / 2);\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-items:not(.elementor-inline-items)\n  .elementor-icon-list-item:not(:first-child) {\n  margin-top: calc(25px / 2);\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-items.elementor-inline-items\n  .elementor-icon-list-item {\n  margin-right: calc(25px / 2);\n  margin-left: calc(25px / 2);\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-items.elementor-inline-items {\n  margin-right: calc(-25px / 2);\n  margin-left: calc(-25px / 2);\n}\nbody:not(.rtl)\n  .elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-items.elementor-inline-items\n  .elementor-icon-list-item:after {\n  right: calc(-25px / 2);\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-icon\n  i {\n  color: var(--e-global-color-accent);\n  transition: color 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-icon\n  svg {\n  fill: var(--e-global-color-accent);\n  transition: fill 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-item:hover\n  .elementor-icon-list-icon\n  i {\n  color: var(--e-global-color-0b8b4d2);\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-item:hover\n  .elementor-icon-list-icon\n  svg {\n  fill: var(--e-global-color-0b8b4d2);\n}\n.elementor-1652 .elementor-element.elementor-element-37ea6f4 {\n  --e-icon-list-icon-size: 20px;\n  --icon-vertical-offset: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-text {\n  color: var(--e-global-color-accent);\n  transition: color 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-item:hover\n  .elementor-icon-list-text {\n  color: var(--e-global-color-0b8b4d2);\n}\n.elementor-1652 .elementor-element.elementor-element-13b0a15 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: center;\n  --gap: 6% 6%;\n  --background-transition: 0.3s;\n  --padding-top: 50px;\n  --padding-bottom: 50px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652 .elementor-element.elementor-element-1ee596c {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n  --border-radius: 30px 30px 30px 30px;\n  --padding-top: 40px;\n  --padding-bottom: 40px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1ee596c:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-color: var(--e-global-color-6545aeb);\n}\n.elementor-1652 .elementor-element.elementor-element-1ee596c,\n.elementor-1652 .elementor-element.elementor-element-1ee596c::before {\n  --border-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-8ee0213 img {\n  width: 90%;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 12px 60px 0\n    rgba(32, 36.00000000000005, 138, 0.058823529411764705);\n}\n.elementor-1652 .elementor-element.elementor-element-8039c31 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-86264bd .elementor-button {\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.11em;\n  letter-spacing: 0.6px;\n  fill: var(--e-global-color-accent);\n  color: var(--e-global-color-accent);\n  background-color: #f3f5ff;\n  padding: 14px 24px 14px 24px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-86264bd\n  > .elementor-widget-container {\n  margin: 0 0 10px 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-04e3ec4\n  .elementor-icon-box-wrapper {\n  text-align: left;\n}\n.elementor-1652 .elementor-element.elementor-element-8c0b439 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: flex-start;\n  --gap: 2% 2%;\n  --flex-wrap: wrap;\n  --background-transition: 0.3s;\n  --padding-top: 0px;\n  --padding-bottom: 100px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-363e4a7\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-363e4a7 {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-43a1a89\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-43a1a89 {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-926997b\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-926997b {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652 .elementor-element.elementor-element-656778a {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: center;\n  --gap: 6% 6%;\n  --background-transition: 0.3s;\n  --padding-top: 100px;\n  --padding-bottom: 80px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652 .elementor-element.elementor-element-229ba6d {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-a7504da .elementor-button {\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.11em;\n  letter-spacing: 0.6px;\n  fill: var(--e-global-color-accent);\n  color: var(--e-global-color-accent);\n  background-color: #f3f5ff;\n  padding: 14px 24px 14px 24px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-a7504da\n  > .elementor-widget-container {\n  margin: 0 0 10px 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-75e417e\n  .elementor-icon-box-wrapper {\n  text-align: left;\n}\n.elementor-1652 .elementor-element.elementor-element-1f388bb {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n  --border-radius: 30px 30px 30px 30px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1f388bb:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-color: var(--e-global-color-6545aeb);\n}\n.elementor-1652 .elementor-element.elementor-element-1f388bb,\n.elementor-1652 .elementor-element.elementor-element-1f388bb::before {\n  --border-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-5126345 {\n  text-align: right;\n}\n.elementor-1652 .elementor-element.elementor-element-5126345 img {\n  width: 100%;\n}\n.elementor-1652 .elementor-element.elementor-element-eaae3f2 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: flex-start;\n  --gap: 2% 2%;\n  --flex-wrap: wrap;\n  --background-transition: 0.3s;\n  --padding-top: 0px;\n  --padding-bottom: 100px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-136561f\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-136561f {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-1d2c35c\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-1d2c35c {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-ea4471c\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-ea4471c {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652 .elementor-element.elementor-element-f1228cf {\n  --display: flex;\n  --background-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-6ae8ef6 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: center;\n  --gap: 6% 6%;\n  --background-transition: 0.3s;\n  --padding-top: 150px;\n  --padding-bottom: 100px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652 .elementor-element.elementor-element-95f4f13 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n  --border-radius: 30px 30px 30px 30px;\n  --padding-top: 40px;\n  --padding-bottom: 40px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-95f4f13:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-color: var(--e-global-color-6545aeb);\n}\n.elementor-1652 .elementor-element.elementor-element-95f4f13,\n.elementor-1652 .elementor-element.elementor-element-95f4f13::before {\n  --border-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-7e97d70 img {\n  width: 91%;\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #d9dbe96e;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 12px 60px 0\n    rgba(32, 36.00000000000005, 138, 0.058823529411764705);\n}\n.elementor-1652 .elementor-element.elementor-element-e0d7628 img {\n  width: 332px;\n  border-radius: 30px 30px 30px 30px;\n}\nbody:not(.rtl) .elementor-1652 .elementor-element.elementor-element-e0d7628 {\n  left: -101px;\n}\n.elementor-1652 .elementor-element.elementor-element-e0d7628 {\n  top: 286px;\n}\n.elementor-1652 .elementor-element.elementor-element-3f5911a {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n}\n.elementor-1652 .elementor-element.elementor-element-65d4e04 .elementor-button {\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.11em;\n  letter-spacing: 0.6px;\n  fill: var(--e-global-color-accent);\n  color: var(--e-global-color-accent);\n  background-color: #f3f5ff;\n  padding: 14px 24px 14px 24px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-65d4e04\n  > .elementor-widget-container {\n  margin: 0 0 10px 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-e0df2b7\n  .elementor-icon-box-wrapper {\n  text-align: left;\n}\n.elementor-1652 .elementor-element.elementor-element-a1cd467 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: calc(\n    (1 - var(--container-widget-flex-grow)) * 100%\n  );\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --align-items: flex-start;\n  --gap: 2% 2%;\n  --flex-wrap: wrap;\n  --background-transition: 0.3s;\n  --padding-top: 0px;\n  --padding-bottom: 120px;\n  --padding-left: 0px;\n  --padding-right: 0px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-155c3b7\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-155c3b7 {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-68f847b\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-68f847b {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  .elementor-image-box-wrapper {\n  text-align: left;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4.elementor-position-top\n  .elementor-image-box-img {\n  margin-bottom: 17px;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  .elementor-image-box-title {\n  margin-bottom: 15px;\n  color: var(--e-global-color-inverse_primary);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  .elementor-image-box-wrapper\n  .elementor-image-box-img {\n  width: 25%;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  .elementor-image-box-img\n  img {\n  transition-duration: 0.3s;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  .elementor-image-box-description {\n  font-size: 18px;\n  line-height: 1.6em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-dd30db4\n  > .elementor-widget-container {\n  margin: 0 0 22px 0;\n  padding: 48px 32px 52px 32px;\n  background-color: var(--e-global-color-0b8b4d2);\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 20px 20px 20px 20px;\n  box-shadow: 0 6px 12px 0 rgb(20 20 43 / 0.0392156862745098);\n}\n.elementor-1652 .elementor-element.elementor-element-dd30db4 {\n  width: var(--container-widget-width, 32%);\n  max-width: 32%;\n  --container-widget-width: 32%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1652 .elementor-element.elementor-element-89e89f8 {\n  --display: flex;\n  --background-transition: 0.3s;\n}\n@media (min-width: 768px) {\n  .elementor-1652 .elementor-element.elementor-element-1ee596c {\n    --width: 50%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-8039c31 {\n    --width: 50%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-229ba6d {\n    --width: 50%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-1f388bb {\n    --width: 50%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-95f4f13 {\n    --width: 50%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-3f5911a {\n    --width: 50%;\n  }\n}\n@media (max-width: 1024px) {\n  .elementor-1652\n    .elementor-element.elementor-element-df61ea6\n    > .elementor-shape-bottom\n    svg,\n  .elementor-1652\n    .elementor-element.elementor-element-df61ea6\n    > .e-con-inner\n    > .elementor-shape-bottom\n    svg {\n    height: 100px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-df61ea6 {\n    --padding-top: 80px;\n    --padding-bottom: 150px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    .elementor-icon-box-title,\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    .elementor-icon-box-title\n    a {\n    font-size: 48px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-13b0a15 {\n    --gap: 2% 2%;\n    --padding-top: 40px;\n    --padding-bottom: 40px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-04e3ec4\n    .elementor-icon-box-description {\n    font-size: 1rem;\n  }\n  .elementor-1652 .elementor-element.elementor-element-8c0b439 {\n    --padding-top: 0px;\n    --padding-bottom: 80px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-656778a {\n    --gap: 2% 2%;\n    --padding-top: 40px;\n    --padding-bottom: 40px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-75e417e\n    .elementor-icon-box-description {\n    font-size: 1rem;\n  }\n  .elementor-1652 .elementor-element.elementor-element-eaae3f2 {\n    --padding-top: 0px;\n    --padding-bottom: 80px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-6ae8ef6 {\n    --gap: 2% 2%;\n    --padding-top: 40px;\n    --padding-bottom: 40px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-e0df2b7\n    .elementor-icon-box-description {\n    font-size: 1rem;\n  }\n  .elementor-1652 .elementor-element.elementor-element-a1cd467 {\n    --padding-top: 0px;\n    --padding-bottom: 80px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4.elementor-position-top\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 35%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-title {\n    font-size: 22px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-description {\n    font-size: 16px;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    > .elementor-widget-container {\n    padding: 28px 28px 28px 28px;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-1652\n    .elementor-element.elementor-element-df61ea6\n    > .elementor-shape-bottom\n    svg,\n  .elementor-1652\n    .elementor-element.elementor-element-df61ea6\n    > .e-con-inner\n    > .elementor-shape-bottom\n    svg {\n    height: 50px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-df61ea6 {\n    --padding-top: 50px;\n    --padding-bottom: 50px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    .elementor-icon-box-title,\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    .elementor-icon-box-title\n    a {\n    font-size: 34px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    .elementor-icon-box-description {\n    font-size: 1rem;\n    line-height: 1.5em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-287395a\n    > .elementor-widget-container {\n    margin: 0 0 0 0;\n  }\n  .elementor-1652 .elementor-element.elementor-element-37ea6f4 {\n    width: 100%;\n    max-width: 100%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-13b0a15 {\n    --padding-top: 20px;\n    --padding-bottom: 20px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-1ee596c {\n    --margin-top: 0px;\n    --margin-bottom: 30px;\n    --margin-left: 0px;\n    --margin-right: 0px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-86264bd\n    .elementor-button {\n    font-size: 14px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-86264bd\n    > .elementor-widget-container {\n    margin: 0 0 0 0;\n  }\n  .elementor-1652 .elementor-element.elementor-element-8c0b439 {\n    --padding-top: 10px;\n    --padding-bottom: 50px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-363e4a7\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-363e4a7 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-43a1a89\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-43a1a89 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-926997b\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-926997b {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-656778a {\n    --padding-top: 20px;\n    --padding-bottom: 20px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-a7504da\n    .elementor-button {\n    font-size: 14px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-a7504da\n    > .elementor-widget-container {\n    margin: 0 0 0 0;\n  }\n  .elementor-1652 .elementor-element.elementor-element-1f388bb {\n    --margin-top: 0px;\n    --margin-bottom: 30px;\n    --margin-left: 0px;\n    --margin-right: 0px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-eaae3f2 {\n    --padding-top: 10px;\n    --padding-bottom: 50px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-136561f\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-136561f {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-1d2c35c\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-1d2c35c {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-ea4471c\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-ea4471c {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-6ae8ef6 {\n    --padding-top: 20px;\n    --padding-bottom: 20px;\n    --padding-left: 20px;\n    --padding-right: 20px;\n  }\n  .elementor-1652 .elementor-element.elementor-element-95f4f13 {\n    --margin-top: 0px;\n    --margin-bottom: 30px;\n    --margin-left: 0px;\n    --margin-right: 0px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-65d4e04\n    .elementor-button {\n    font-size: 14px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-65d4e04\n    > .elementor-widget-container {\n    margin: 0 0 0 0;\n  }\n  .elementor-1652 .elementor-element.elementor-element-a1cd467 {\n    --padding-top: 10px;\n    --padding-bottom: 50px;\n    --padding-left: 10px;\n    --padding-right: 10px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-155c3b7\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-155c3b7 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-68f847b\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-68f847b {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-img {\n    margin-bottom: 2px;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-title {\n    margin-bottom: 1px;\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1652\n    .elementor-element.elementor-element-dd30db4\n    .elementor-image-box-wrapper\n    .elementor-image-box-img {\n    width: 25%;\n  }\n  .elementor-1652 .elementor-element.elementor-element-dd30db4 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-item\n  a {\n  padding: 22px 44px 22px 53px;\n  border: 1px solid #eff0f6;\n  border-radius: 10000000000px;\n  background-color: #fff;\n  box-shadow: 0 5px 5px 0 rgb(11 10 51 / 0.01),\n    0 1px 3px 0 rgb(68 87 255 / 0.02), 0 4px 11px 0 rgb(68 87 255 / 0.06);\n  transition: all 0.3s;\n  -webkit-transition: all 0.3s;\n  line-height: 1.111em;\n}\n.elementor-1652\n  .elementor-element.elementor-element-37ea6f4\n  .elementor-icon-list-item\n  a:hover {\n  border-color: #4457ff;\n  background-color: #5335d9;\n  box-shadow: none;\n}\n@media only screen and (max-width: 767px) {\n  .elementor-1652 .elementor-element.elementor-element-37ea6f4 ul {\n    flex-direction: column !important;\n  }\n  .elementor-1652 .elementor-element.elementor-element-37ea6f4 ul li {\n    margin: 0 0 10px 0;\n  }\n}\n.elementor-1652 .elementor-element.elementor-element-8c0b439 img {\n  border-radius: 24%;\n}\n.im-bx-r img {\n  border-radius: 24%;\n}\n.elementor-1652 .elementor-element.elementor-element-e0d7628 img {\n  box-shadow: 0 11px 24px 0 rgb(32 36 138 / 9%);\n}\n.elementor-1652 .elementor-element.elementor-element-a1cd467 img {\n  border-radius: 24%;\n}\n.elementor-1652 .elementor-element.elementor-element-a1cd467 > .e-con-inner {\n  border-bottom: 1px solid var(--e-global-color-ce0cfb7);\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf590592ecb6f2_THICCCBOI-Bold.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf597b00ecb6f3_THICCCBOI-Medium.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62d15c6f9acf599227ecb6f4_THICCCBOI-SemiBold.ttf)\n    format(\"truetype\");\n}\n@font-face {\n  font-family: \"thicccboi\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://planzer.io/wp-content/uploads/2022/11/62e22028e877056d28819f41_THICCCBOI-Regular.ttf)\n    format(\"truetype\");\n}\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor-widget-image {\n  text-align: center;\n}\n.elementor-widget-image a {\n  display: inline-block;\n}\n.elementor-widget-image img {\n  vertical-align: middle;\n  display: inline-block;\n}\n@keyframes hide-scroll {\n  0%,\n  to {\n    overflow: hidden;\n  }\n}\n\n/*! elementor - v3.22.0 - 26-06-2024 */\n\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor-widget-icon-box .elementor-icon-box-wrapper {\n  display: block;\n  text-align: center;\n}\n.elementor-widget-icon-box.elementor-position-top .elementor-icon-box-wrapper {\n  display: block;\n  text-align: center;\n  flex-direction: unset;\n}\n.elementor-widget-icon-box .elementor-icon-box-title a {\n  color: inherit;\n}\n.elementor-widget-icon-box .elementor-icon-box-content {\n  flex-grow: 1;\n}\n.elementor-widget-icon-box .elementor-icon-box-description {\n  margin: 0;\n}\n\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor-widget.elementor-icon-list--layout-inline\n  .elementor-widget-container {\n  overflow: hidden;\n}\n.elementor-widget .elementor-icon-list-items.elementor-inline-items {\n  /*margin-right: -8px;*/\n  /*margin-left: -8px;*/\n}\n.elementor-widget\n  .elementor-icon-list-items.elementor-inline-items\n  .elementor-icon-list-item {\n  margin-right: 8px;\n  margin-left: 8px;\n}\n.elementor-widget\n  .elementor-icon-list-items.elementor-inline-items\n  .elementor-icon-list-item:after {\n  width: auto;\n  left: auto;\n  right: auto;\n  position: relative;\n  height: 100%;\n  border-top: 0;\n  border-bottom: 0;\n  border-right: 0;\n  border-left-width: 1px;\n  border-style: solid;\n  right: -8px;\n}\n.elementor-widget .elementor-icon-list-items {\n  /*list-style-type: none;*/\n  /*margin: 0;*/\n  /*padding: 0;*/\n}\n.elementor-widget .elementor-icon-list-item {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.elementor-widget .elementor-icon-list-item:after {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n.elementor-widget .elementor-icon-list-item,\n.elementor-widget .elementor-icon-list-item a {\n  display: flex;\n  font-size: inherit;\n  align-items: var(--icon-vertical-align, center);\n}\n.elementor-widget .elementor-icon-list-icon + .elementor-icon-list-text {\n  align-self: center;\n  padding-inline-start: 5px;\n}\n.elementor-widget .elementor-icon-list-icon {\n  display: flex;\n  position: relative;\n  top: var(--icon-vertical-offset, initial);\n}\n.elementor-widget .elementor-icon-list-icon svg {\n  width: var(--e-icon-list-icon-size, 1em);\n  height: var(--e-icon-list-icon-size, 1em);\n}\n.elementor-widget .elementor-icon-list-icon i {\n  width: 1.25em;\n  font-size: var(--e-icon-list-icon-size);\n}\n.elementor-widget.elementor-widget-icon-list .elementor-icon-list-icon {\n  text-align: var(--e-icon-list-icon-align);\n}\n.elementor-widget.elementor-widget-icon-list .elementor-icon-list-icon svg {\n  margin: var(\n    --e-icon-list-icon-margin,\n    0 calc(var(--e-icon-list-icon-size, 1em) * 0.25) 0 0\n  );\n}\n.elementor-widget.elementor-list-item-link-full_width a {\n  width: 100%;\n}\n.elementor-widget.elementor-align-left .elementor-icon-list-item,\n.elementor-widget.elementor-align-left .elementor-icon-list-item a {\n  justify-content: flex-start;\n  text-align: left;\n}\n.elementor-widget.elementor-align-left .elementor-inline-items {\n  justify-content: flex-start;\n}\n.elementor-widget.elementor-align-right .elementor-icon-list-item,\n.elementor-widget.elementor-align-right .elementor-icon-list-item a {\n  justify-content: flex-end;\n  text-align: right;\n}\n.elementor-widget.elementor-align-right .elementor-icon-list-items {\n  justify-content: flex-end;\n}\n.elementor-widget:not(.elementor-align-right) .elementor-icon-list-item:after {\n  left: 0;\n}\n.elementor-widget:not(.elementor-align-left) .elementor-icon-list-item:after {\n  right: 0;\n}\n@media (min-width: -1) {\n  .elementor-widget:not(.elementor-widescreen-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-widescreen-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n@media (max-width: -1) {\n  .elementor-widget:not(.elementor-laptop-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-laptop-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n@media (max-width: -1) {\n  .elementor-widget:not(.elementor-tablet_extra-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-tablet_extra-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n@media (max-width: 1024px) {\n  .elementor-widget:not(.elementor-tablet-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-tablet-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n@media (max-width: -1) {\n  .elementor-widget:not(.elementor-mobile_extra-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-mobile_extra-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-widget:not(.elementor-mobile-align-right)\n    .elementor-icon-list-item:after {\n    left: 0;\n  }\n  .elementor-widget:not(.elementor-mobile-align-left)\n    .elementor-icon-list-item:after {\n    right: 0;\n  }\n}\n\n/*! elementor - v3.22.0 - 26-06-2024 */\nbody.elementor-page .elementor-widget-menu-anchor {\n  margin-bottom: 0;\n}\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor-widget-image-box .elementor-image-box-content {\n  width: 100%;\n}\n@media (min-width: 768px) {\n  .elementor-widget-image-box.elementor-position-top .elementor-image-box-img {\n    margin: auto;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-widget-image-box .elementor-image-box-img {\n    margin-left: auto !important;\n    margin-right: auto !important;\n    margin-bottom: 15px;\n  }\n}\n.elementor-widget-image-box .elementor-image-box-img {\n  display: inline-block;\n}\n.elementor-widget-image-box .elementor-image-box-title a {\n  color: inherit;\n}\n.elementor-widget-image-box .elementor-image-box-wrapper {\n  text-align: center;\n}\n.elementor-widget-image-box .elementor-image-box-description {\n  margin: 0;\n}\n/*! elementor - v3.22.0 - 26-06-2024 */\n.elementor-heading-title {\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n.elementor-widget-heading\n  .elementor-heading-title[class*=\"elementor-size-\"]\n  > a {\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n/*! elementor-pro - v3.21.0 - 15-04-2024 */\n/*! elementor - v3.22.0 - 26-06-2024 */\n\n@keyframes bounce {\n  20%,\n  53%,\n  80%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0);\n  }\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0);\n  }\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -15px, 0);\n  }\n  90% {\n    transform: translate3d(0, -4px, 0);\n  }\n}\n@keyframes flash {\n  50%,\n  from,\n  to {\n    opacity: 1;\n  }\n  25%,\n  75% {\n    opacity: 0;\n  }\n}\n@keyframes pulse {\n  from,\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n}\n@keyframes rubberBand {\n  from,\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n}\n@keyframes shake {\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n}\n@keyframes headShake {\n  0% {\n    transform: translateX(0);\n  }\n  6.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n  18.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n  31.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n  43.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n  50% {\n    transform: translateX(0);\n  }\n}\n@keyframes swing {\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n}\n@keyframes tada {\n  from,\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n  10%,\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n  }\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n  40%,\n  60%,\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n}\n@keyframes wobble {\n  from,\n  to {\n    transform: none;\n  }\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n}\n@keyframes jello {\n  11.1%,\n  from,\n  to {\n    transform: none;\n  }\n  22.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n  33.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n  44.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n  55.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n  66.6% {\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n  77.7% {\n    transform: skewX(0.390625deg) skewY(0.390625deg);\n  }\n  88.8% {\n    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n  }\n}\n@keyframes bounceIn {\n  20%,\n  40%,\n  60%,\n  80%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  40% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n  80% {\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n}\n@keyframes bounceInDown {\n  60%,\n  75%,\n  90%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes bounceInLeft {\n  60%,\n  75%,\n  90%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes bounceInRight {\n  60%,\n  75%,\n  90%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes bounceInUp {\n  60%,\n  75%,\n  90%,\n  from,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUp {\n  animation-name: fadeInUp;\n}\n@keyframes lightSpeedIn {\n  from {\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n  80% {\n    transform: skewX(-5deg);\n    opacity: 1;\n  }\n  to {\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rotateIn {\n  from {\n    transform-origin: center;\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: center;\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rotateInDownLeft {\n  from {\n    transform-origin: left bottom;\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rotateInDownRight {\n  from {\n    transform-origin: right bottom;\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rotateInUpLeft {\n  from {\n    transform-origin: left bottom;\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rotateInUpRight {\n  from {\n    transform-origin: right bottom;\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n@keyframes rollIn {\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes zoomInDown {\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n@keyframes zoomInLeft {\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n@keyframes zoomInRight {\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n@keyframes zoomInUp {\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n@keyframes slideInDown {\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes slideInLeft {\n  from {\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes slideInRight {\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes slideInUp {\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.elementor-animation-shrink {\n  transition-duration: 0.3s;\n  transition-property: transform;\n}\n.elementor-animation-shrink:active,\n.elementor-animation-shrink:focus,\n.elementor-animation-shrink:hover {\n  transform: scale(0.9);\n}\n@keyframes elementor-animation-pulse {\n  25% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: scale(0.9);\n  }\n}\n@keyframes elementor-animation-pulse-grow {\n  to {\n    transform: scale(1.1);\n  }\n}\n@keyframes elementor-animation-pulse-shrink {\n  to {\n    transform: scale(0.9);\n  }\n}\n@keyframes elementor-animation-push {\n  50% {\n    transform: scale(0.8);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes elementor-animation-pop {\n  50% {\n    transform: scale(1.2);\n  }\n}\n@keyframes elementor-animation-bob {\n  0% {\n    transform: translateY(-8px);\n  }\n  50% {\n    transform: translateY(-4px);\n  }\n  100% {\n    transform: translateY(-8px);\n  }\n}\n@keyframes elementor-animation-bob-float {\n  100% {\n    transform: translateY(-8px);\n  }\n}\n@keyframes elementor-animation-hang {\n  0% {\n    transform: translateY(8px);\n  }\n  50% {\n    transform: translateY(4px);\n  }\n  100% {\n    transform: translateY(8px);\n  }\n}\n@keyframes elementor-animation-hang-sink {\n  100% {\n    transform: translateY(8px);\n  }\n}\n@keyframes elementor-animation-wobble-vertical {\n  16.65% {\n    transform: translateY(8px);\n  }\n  33.3% {\n    transform: translateY(-6px);\n  }\n  49.95% {\n    transform: translateY(4px);\n  }\n  66.6% {\n    transform: translateY(-2px);\n  }\n  83.25% {\n    transform: translateY(1px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@keyframes elementor-animation-wobble-horizontal {\n  16.65% {\n    transform: translateX(8px);\n  }\n  33.3% {\n    transform: translateX(-6px);\n  }\n  49.95% {\n    transform: translateX(4px);\n  }\n  66.6% {\n    transform: translateX(-2px);\n  }\n  83.25% {\n    transform: translateX(1px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes elementor-animation-wobble-to-bottom-right {\n  16.65% {\n    transform: translate(8px, 8px);\n  }\n  33.3% {\n    transform: translate(-6px, -6px);\n  }\n  49.95% {\n    transform: translate(4px, 4px);\n  }\n  66.6% {\n    transform: translate(-2px, -2px);\n  }\n  83.25% {\n    transform: translate(1px, 1px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes elementor-animation-wobble-to-top-right {\n  16.65% {\n    transform: translate(8px, -8px);\n  }\n  33.3% {\n    transform: translate(-6px, 6px);\n  }\n  49.95% {\n    transform: translate(4px, -4px);\n  }\n  66.6% {\n    transform: translate(-2px, 2px);\n  }\n  83.25% {\n    transform: translate(1px, -1px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes elementor-animation-wobble-top {\n  16.65% {\n    transform: skew(-12deg);\n  }\n  33.3% {\n    transform: skew(10deg);\n  }\n  49.95% {\n    transform: skew(-6deg);\n  }\n  66.6% {\n    transform: skew(4deg);\n  }\n  83.25% {\n    transform: skew(-2deg);\n  }\n  100% {\n    transform: skew(0);\n  }\n}\n@keyframes elementor-animation-wobble-bottom {\n  16.65% {\n    transform: skew(-12deg);\n  }\n  33.3% {\n    transform: skew(10deg);\n  }\n  49.95% {\n    transform: skew(-6deg);\n  }\n  66.6% {\n    transform: skew(4deg);\n  }\n  83.25% {\n    transform: skew(-2deg);\n  }\n  100% {\n    transform: skew(0);\n  }\n}\n@keyframes elementor-animation-wobble-skew {\n  16.65% {\n    transform: skew(-12deg);\n  }\n  33.3% {\n    transform: skew(10deg);\n  }\n  49.95% {\n    transform: skew(-6deg);\n  }\n  66.6% {\n    transform: skew(4deg);\n  }\n  83.25% {\n    transform: skew(-2deg);\n  }\n  100% {\n    transform: skew(0);\n  }\n}\n@keyframes elementor-animation-buzz {\n  50% {\n    transform: translateX(3px) rotate(2deg);\n  }\n  100% {\n    transform: translateX(-3px) rotate(-2deg);\n  }\n}\n@keyframes elementor-animation-buzz-out {\n  10% {\n    transform: translateX(3px) rotate(2deg);\n  }\n  20% {\n    transform: translateX(-3px) rotate(-2deg);\n  }\n  30% {\n    transform: translateX(3px) rotate(2deg);\n  }\n  40% {\n    transform: translateX(-3px) rotate(-2deg);\n  }\n  50% {\n    transform: translateX(2px) rotate(1deg);\n  }\n  60% {\n    transform: translateX(-2px) rotate(-1deg);\n  }\n  70% {\n    transform: translateX(2px) rotate(1deg);\n  }\n  80% {\n    transform: translateX(-2px) rotate(-1deg);\n  }\n  90% {\n    transform: translateX(1px) rotate(0);\n  }\n  100% {\n    transform: translateX(-1px) rotate(0);\n  }\n}\n.elementor-1770 .elementor-element.elementor-element-43c693e0 {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: initial;\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --background-transition: 0.3s;\n  --border-radius: 50px 50px 50px 50px;\n  --padding-top: 110px;\n  --padding-bottom: 135px;\n  --padding-left: 54px;\n  --padding-right: 54px;\n}\n.elementor-1770\n  .elementor-element.elementor-element-43c693e0:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-image: url(\"data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20%20%22%3E%3C/svg%3E#}https://planzer.io/wp-content/uploads/2023/01/bg-shape-5.png\");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.elementor-1770 .elementor-element.elementor-element-43c693e0,\n.elementor-1770 .elementor-element.elementor-element-43c693e0::before {\n  --border-transition: 0.3s;\n}\n.elementor-1770\n  .elementor-element.elementor-element-75867125\n  .elementor-heading-title {\n  color: var(--e-global-color-0b8b4d2);\n  font-family: \"thicccboi\", Sans-serif;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.3em;\n}\n.elementor-1770 .elementor-element.elementor-element-75867125 {\n  width: var(--container-widget-width, 50%);\n  max-width: 50%;\n  --container-widget-width: 50%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1770\n  .elementor-element.elementor-element-58fe34d3\n  .elementor-button {\n  font-size: 22px;\n  font-weight: 700;\n  fill: var(--e-global-color-accent);\n  color: var(--e-global-color-accent);\n  background-color: var(--e-global-color-0b8b4d2);\n  border-radius: 18px 18px 18px 18px;\n  padding: 36px 36px 36px 36px;\n}\n.elementor-1770 .elementor-element.elementor-element-58fe34d3 {\n  width: var(--container-widget-width, 50%);\n  max-width: 50%;\n  --container-widget-width: 50%;\n  --container-widget-flex-grow: 0;\n}\n.elementor-1770\n  .elementor-element.elementor-element-58fe34d3.elementor-element {\n  --align-self: center;\n}\n@media (max-width: 1024px) {\n  .elementor-1770 .elementor-element.elementor-element-43c693e0 {\n    --padding-top: 100px;\n    --padding-bottom: 100px;\n    --padding-left: 40px;\n    --padding-right: 40px;\n  }\n  .elementor-1770\n    .elementor-element.elementor-element-75867125\n    .elementor-heading-title {\n    font-size: 30px;\n  }\n  .elementor-1770\n    .elementor-element.elementor-element-58fe34d3\n    .elementor-button {\n    padding: 25px 25px 25px 25px;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-1770 .elementor-element.elementor-element-43c693e0 {\n    --border-radius: 30px 30px 30px 30px;\n    --padding-top: 50px;\n    --padding-bottom: 50px;\n    --padding-left: 30px;\n    --padding-right: 30px;\n  }\n  .elementor-1770\n    .elementor-element.elementor-element-75867125\n    .elementor-heading-title {\n    font-size: 26px;\n    line-height: 1.2em;\n  }\n  .elementor-1770\n    .elementor-element.elementor-element-75867125\n    > .elementor-widget-container {\n    margin: 0 0 15px 0;\n  }\n  .elementor-1770 .elementor-element.elementor-element-75867125 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n  .elementor-1770\n    .elementor-element.elementor-element-58fe34d3\n    .elementor-button {\n    font-size: 18px;\n    padding: 20px 20px 20px 20px;\n  }\n  .elementor-1770 .elementor-element.elementor-element-58fe34d3 {\n    --container-widget-width: 100%;\n    --container-widget-flex-grow: 0;\n    width: var(--container-widget-width, 100%);\n    max-width: 100%;\n  }\n}\n.elementor-1566 .elementor-element.elementor-element-633576a6 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n  --margin-top: 80px;\n  --margin-bottom: 120px;\n  --margin-left: 0px;\n  --margin-right: 0px;\n}\n.elementor-1566 .elementor-element.elementor-element-2a4fb96c {\n  --display: flex;\n  --flex-direction: row;\n  --container-widget-width: initial;\n  --container-widget-height: 100%;\n  --container-widget-flex-grow: 1;\n  --container-widget-align-self: stretch;\n  --background-transition: 0.3s;\n  --border-radius: 50px 50px 50px 50px;\n  --padding-top: 50px;\n  --padding-bottom: 50px;\n  --padding-left: 50px;\n  --padding-right: 50px;\n}\n.elementor-1566\n  .elementor-element.elementor-element-2a4fb96c:not(\n    .elementor-motion-effects-element-type-background\n  ) {\n  background-color: var(--e-global-color-accent);\n}\n.elementor-1566 .elementor-element.elementor-element-2a4fb96c,\n.elementor-1566 .elementor-element.elementor-element-2a4fb96c::before {\n  --border-transition: 0.3s;\n}\n.elementor-1566 .elementor-element.elementor-element-672681a4 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --justify-content: center;\n  --background-transition: 0.3s;\n}\n.elementor-1566\n  .elementor-element.elementor-element-79038120\n  .elementor-heading-title {\n  color: #fff;\n}\n.elementor-1566\n  .elementor-element.elementor-element-30942c0e\n  .elementor-button {\n  font-size: 18px;\n  font-weight: 600;\n  fill: var(--e-global-color-accent);\n  color: var(--e-global-color-accent);\n  background-color: var(--e-global-color-0b8b4d2);\n}\n.elementor-1566\n  .elementor-element.elementor-element-30942c0e\n  .elementor-button:hover,\n.elementor-1566\n  .elementor-element.elementor-element-30942c0e\n  .elementor-button:focus {\n  color: var(--e-global-color-0b8b4d2);\n  background-color: var(--e-global-color-inverse_primary);\n}\n.elementor-1566\n  .elementor-element.elementor-element-30942c0e\n  .elementor-button:hover\n  svg,\n.elementor-1566\n  .elementor-element.elementor-element-30942c0e\n  .elementor-button:focus\n  svg {\n  fill: var(--e-global-color-0b8b4d2);\n}\n.elementor-1566 .elementor-element.elementor-element-2e0d5022 {\n  --display: flex;\n  --flex-direction: column;\n  --container-widget-width: 100%;\n  --container-widget-height: initial;\n  --container-widget-flex-grow: 0;\n  --container-widget-align-self: initial;\n  --background-transition: 0.3s;\n}\n.elementor-1566 .elementor-element.elementor-element-71772c73 img {\n  width: 100%;\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 25px 25px 25px 25px;\n}\nbody:not(.rtl) .elementor-1566 .elementor-element.elementor-element-71772c73 {\n  left: 0%;\n}\n.elementor-1566 .elementor-element.elementor-element-71772c73 {\n  bottom: 10%;\n}\n.elementor-1566 .elementor-element.elementor-element-60ddee1b {\n  text-align: right;\n}\n.elementor-1566 .elementor-element.elementor-element-60ddee1b img {\n  width: 80%;\n  border-style: solid;\n  border-width: 1px 1px 1px 1px;\n  border-color: #eff0f6;\n  border-radius: 25px 25px 25px 25px;\n  box-shadow: 0 -6px 24px 0 rgb(0 0 0 / 0.07);\n}\n.elementor-1566\n  .elementor-element.elementor-element-60ddee1b\n  > .elementor-widget-container {\n  margin: -100px 0 0 0;\n}\n@media (max-width: 1024px) {\n  .elementor-1566\n    .elementor-element.elementor-element-30942c0e\n    .elementor-button {\n    font-size: 16px;\n  }\n  .elementor-1566 .elementor-element.elementor-element-71772c73 img {\n    width: 162px;\n  }\n  .elementor-1566 .elementor-element.elementor-element-60ddee1b img {\n    width: 100%;\n  }\n  .elementor-1566\n    .elementor-element.elementor-element-60ddee1b\n    > .elementor-widget-container {\n    margin: -100px 0 0 0;\n  }\n}\n@media (max-width: 767px) {\n  .elementor-1566 .elementor-element.elementor-element-633576a6 {\n    --margin-top: 40px;\n    --margin-bottom: 100px;\n    --margin-left: 0px;\n    --margin-right: 0px;\n  }\n  .elementor-1566 .elementor-element.elementor-element-2a4fb96c {\n    --border-radius: 30px 30px 30px 30px;\n    --padding-top: 30px;\n    --padding-bottom: 40px;\n    --padding-left: 25px;\n    --padding-right: 25px;\n  }\n  .elementor-1566 .elementor-element.elementor-element-2e0d5022 {\n    --padding-top: 0px;\n    --padding-bottom: 0px;\n    --padding-left: 0px;\n    --padding-right: 0px;\n  }\n  .elementor-1566\n    .elementor-element.elementor-element-60ddee1b\n    > .elementor-widget-container {\n    margin: 0 0 0 0;\n  }\n}\n@media (min-width: 768px) {\n  .elementor-1566 .elementor-element.elementor-element-672681a4 {\n    --width: 50%;\n  }\n  .elementor-1566 .elementor-element.elementor-element-2e0d5022 {\n    --width: 50%;\n  }\n}\n.elementor-1566 .elementor-element.elementor-element-71772c73 {\n  box-shadow: 0 34px 87px 0 rgb(32 36 138 / 9%);\n}\n.elementor-1566 .elementor-element.elementor-element-60ddee1b {\n  box-shadow: 0 3px 28px 0 rgb(32 36 138 / 6%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
